<template>
<div class="standard_head">
    <div class="left_content" :style="divWidth">
        <span v-show="'0' == agentInfo.employeeType" :class="{'font_style':true,'call_mark':true,'opacity':opacity1}" style="margin-left: 21px" @click="checkInOrOut">
            <div class="img_div"><img class="title_content_btn" src="../../assets/image/sigBtnBlue.png" /></div>
            <div class="img_icon_font">{{checkInOrOutText}}</div>
        </span>

        <span v-show="'0' == agentInfo.employeeType" :class="{'font_style':true,'call_mark':true,'opacity':opacity3}" @click="callOut('0')">
            <div class="img_div"><img class="title_content_btn" src="../../assets/image/callBlue.png" /></div>
            <div class="img_icon_font">内呼</div>
        </span>

        <span v-show="'0' == agentInfo.employeeType" :class="{'font_style':true,'call_mark':true,'opacity':opacity4}" @click="callOut('1')">
            <div class="img_div"><img class="title_content_btn" src="../../assets/image/callOutBlue.png" /></div>
            <div class="img_icon_font">呼出</div>
        </span>

        <span v-show="'0' == agentInfo.employeeType" :class="{'font_style':true,'call_mark':true,'opacity':opacity5}" @click="callOut('2')">
            <div class="img_div"><img class="title_content_btn" src="../../assets/image/hangUpBlue.png" /></div>
            <div class="img_icon_font">挂断</div>
        </span>

        <span v-show="'0' == agentInfo.employeeType" :class="{'font_style':true,'call_mark':true,'opacity':opacity6}" @click="callOut('3')" v-if="companyType!='0'">
            <div class="img_div"><img class="title_content_btn" src="../../assets/image/scoreBlue.png" /></div>
            <div class="img_icon_font">满意度</div>
        </span>

        <span v-show="'0' == agentInfo.employeeType" :class="{'font_style':true,'call_mark':true,'opacity':opacity7}" @click="callOut('4')">
            <div class="img_div"><img class="title_content_btn" src="../../assets/image/keepBlue.png" /></div>
            <div class="img_icon_font">保持</div>
        </span>

        <span v-show="'0' == agentInfo.employeeType" :class="{'font_style':true,'call_mark':true,'opacity':opacity8}" @click="callOut('5')">
            <div class="img_div"><img class="title_content_btn" src="../../assets/image/startBlue.png" /></div>
            <div class="img_icon_font">解除保持</div>
        </span>
        <span v-show="'0' == agentInfo.employeeType" :class="{'font_style':true,'call_mark':true,'opacity':opacity9}" style="margin-right: 10px;">
            <div class="img_div"><img class="title_content_btn" src="../../assets/image/transferBlue.png" /></div>
            <div class="img_icon_font">
                <Dropdown trigger="click" @on-click="transfer">
                    <a href="javascript:void(0)" class="transfer">转接<Icon type="ios-arrow-down"></Icon></a>
                    <DropdownMenu slot="list">
                        <DropdownItem name="agent">转接座席</DropdownItem>
                        <DropdownItem name="queue">转接技能组</DropdownItem>
                        <DropdownItem name="ivr">转接IVR</DropdownItem>
                        <DropdownItem name="pstn">转接外线</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
        </span>
        <span v-show="'0' == agentInfo.employeeType" :class="{'font_style':true,'call_mark':true,'opacity':opacity10}">
            <div class="img_div"><img class="title_content_btn" src="../../assets/image/enquireBlue.png" /></div>
            <div class="img_icon_font">
                <Dropdown trigger="click" @on-click="transfer">
                    <a href="javascript:void(0)" class="transfer">询问<Icon type="ios-arrow-down"></Icon></a>
                    <DropdownMenu slot="list">
                        <DropdownItem name="askAgent">询问座席</DropdownItem>
                        <DropdownItem name="askPstn">询问外线</DropdownItem>
                        <DropdownItem name="askTransfer">确定询问</DropdownItem>
                        <DropdownItem name="cancelAsk">取消询问</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
        </span>
        <!-- <span :class="{'font_style':true,'call_mark':true,'opacity':opacity11}">
            <div class="img_div"><img class="title_content_btn" src="../../assets/image/manyBlue.png" /></div>
            <div class="img_icon_font">
                <Dropdown trigger="click" @on-click="transfer">
                    <a href="javascript:void(0)" class="transfer">三方<Icon type="ios-arrow-down"></Icon></a>
                    <DropdownMenu slot="list">
                        <DropdownItem name="threeway">三方座席</DropdownItem>
                        <DropdownItem name="threewayPstn">三方外线</DropdownItem>
                        <DropdownItem name="cancelThreeway">取消三方</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
        </span> -->
        <!-- 多方,'opacity':opacity11 -->
        <span v-show="'0' == agentInfo.employeeType" :class="{'font_style':true,'call_mark':true,'opacity':opacity11}" @click="appearMultiparty">
            <div class="img_div" style="margin-left:10px"><img class="title_content_btn" src="../../assets/image/manyBlue.png" /></div>
             <div class="img_icon_font">多方</div>
        </span>

        <!-- <span :class="{'font_style':true,'call_mark':true,'opacity':opacity12}" style="display: none;" @click="callOut('9')"> -->
        <span v-if="showChat && '0' == agentInfo.employeeType" :class="{'font_style':true,'call_mark':true,'opacity':opacityChat}" @click="getinto()" style="margin-left:20px">
            <div class="img_div"><img class="title_content_btn" src="../../assets/image/onLineBlue.png" /></div>
            <div class="img_icon_font">在线客服</div>
        </span>

        <span>
            <el-drawer size="22%" title="我是标题" :style="screenHeight" :modal-append-to-body="false" :visible.sync="drawer" :with-header="false" :modal="false">
                <div>
                    <div class="know_search_content">
                        <Dropdown :trigger="knowTabsFlag != 'third' ?'click' : 'custom'" @on-visible-change="showKnowTree">
                            <a href="javascript:void(0)">知识助手 <Icon type="ios-arrow-down"></Icon></a>
                            <DropdownMenu slot="list">
                                <div class="ztree" id="knowledgeTree"></div>
                            </DropdownMenu>
                        </Dropdown>
                        <Input v-model="search" placeholder="请输入关键字检索知识库" @on-change="searchContent" />
                    </div>
                    <div class="know_content">
                        <Tabs :animated="false" @on-click="browseNotice" v-model="knowTabsFlag">
                            <Tab-pane label="知识检索" icon="ios-book" name="first">
                                <div v-if="infoTableList.length>0" class="content" style="margin-bottom: 5px;border-radius: 5px;" v-for="(item , index) in infoTableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
                                    <el-collapse>
                                        <el-collapse-item :name="item.id">
                                            <template slot="title">
                                              <p v-html="item.tittle"></p>
                                            </template>
                                            <div class="content" style="width: 100%;max-height: 350px;">
                                                <ul>
                                                    <li>
                                                        <p class="kn_content_style" v-html="item.content"></p>
                                                    </li>
                                                    <li style="padding-top: 10px;">
                                                        <a href="javascript:void(0)" @click="changeLove(item.id,item.collect)" class="el-icon-shopping-cart-2">{{item.collect=='1'?'已收藏':'收藏'}}</a>
                                                        <a href="javascript:void(0)" @click="openKnlgContent(item.id,item.tittle)" class="el-icon-view" style="float: right;padding-right: 5px;line-height: 25px;"></a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </el-collapse-item>
                                    </el-collapse>
                                </div>
                            </Tab-pane>
                            <Tab-pane label="个人收藏" icon="md-heart" name="second">
                                <div v-if="infoTableList.length>0" class="content" style="margin-bottom: 5px;
                    border-radius: 5px;" v-for="(item , index) in infoTableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
                                    <el-collapse>
                                        <el-collapse-item :name="item.id">
                                            <template slot="title">
                                              <p v-html="item.tittle"></p>
                                            </template>
                                            <div class="content" style="width: 100%;height: 100%">
                                                <ul>
                                                    <li>
                                                        <p style="width: 100%;max-height: 300px;overflow-y:hidden; word-break : break-all;white-space:normal;" v-html="item.content"></p>
                                                    </li>
                                                    <li style="padding-top: 10px;">
                                                        <a href="javascript:void(0)" @click="changeLove(item.id)" class="el-icon-shopping-cart-2">已收藏</a>
                                                        <a href="javascript:void(0)" @click="openKnlgContent(item.id,item.tittle)" class="el-icon-view" style="float: right;padding-right: 5px;"></a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </el-collapse-item>
                                    </el-collapse>
                                </div>
                            </Tab-pane>
                            <Tab-pane label="自定义" icon="md-person" name="third" style="text-align: center">
                                <span class="el-icon-circle-plus" @click="addPersonKnow()">&nbsp;添加个人知识</span>
                                <div v-if="infoTableList.length>0" class="content" style="margin-bottom: 5px;border-radius: 5px;" v-for="(item , index) in infoTableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
                                    <el-collapse>
                                        <el-collapse-item :name="item.id">
                                            <template slot="title">
                                              <p v-html="item.tittle"></p>
                                            </template>
                                            <div style="width: 100%;height: 100%">
                                                <ul>
                                                    <li>
                                                        <p style="width: 100%;max-height: 300px;overflow-y:hidden; word-break : break-all;white-space:normal;" v-html="item.content"></p>
                                                    </li>
                                                    <li style="padding-top: 10px;">
                                                        <a href="javascript:void(0)" @click="editPersonKnow(item.id)" class="el-icon-edit" style="padding-left: 10px;float: left">编辑</a>
                                                        <a href="javascript:void(0)" @click="deletePersonKnow(item.id)" class="el-icon-delete" style="padding-left: 10px;float: left">删除</a>
                                                        <a href="javascript:void(0)" @click="openKnlgContent(item.id,item.tittle)" class="el-icon-view" style="float: right"></a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </el-collapse-item>
                                    </el-collapse>
                                </div>
                            </Tab-pane>
                        </Tabs>
                    </div>
                </div>
            </el-drawer>
        </span>
        <div v-if="(phoneType != '0' && phoneType != '4') && signalShow  && '2' != agentInfo.isSupportChat" class="right_img_div signal" @click="checksignal()" :title="sysping">
            <img :src="pingicon" />
        </div>
        <div class="skillselect" style="width:100px;height: 100%;float: right;margin-left:20px;" v-if="skillshow && '2' != agentInfo.isSupportChat">
            <div class="selectDiv" style="width:100px;display:inline-block;float: left;height:50%;">
                <Select style="height:100%;display: inline;" v-model="skillgroup" placeholder="请选择技能组" :title="skillgroup" @on-change="skillchange">
                    <Option v-for="(item, index) in SkillList" :value="item.queueName" :title="item.queueName" :key="index"  style="width:100px">{{item.queueName}}</Option>
                </Select>
            </div>
            <p style="width:75px;font-size:15px;height:50%;display: flex;float: left;align-items: center;justify-content: center;">
                <!-- <span style="font-weight:bold">:</span> -->
              <span style="color:red">{{queuelength}}</span>
              <span style="font-size:12px">人排队</span>
            </p>
        </div>
        <Dropdown class="agent_select" @on-click="outLogin" style="margin-left:5px;">
            <a href="javascript:void(0)">{{loginName}}
                <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
                <DropdownItem name="1">员工工号:{{loginName}}</DropdownItem>
                <DropdownItem v-show="'0' == agentInfo.employeeType" name="2">员工分机:{{agentNumber}}</DropdownItem>
                <DropdownItem name="0">个人设置</DropdownItem>
                <DropdownItem name="3">安全退出</DropdownItem>
            </DropdownMenu>
        </Dropdown>

        <div class="right_img_div people" @click="outLogin('0')" title="个人设置">
            <Avatar :src="employeeHead" />
        </div>
        <div class="right_img_div knowledge">
            <img class="title_content_btn" src="../../assets/image/know.png" title="知识库检索" @click="clickDrawer" />
        </div>
        <div v-if="showChat || '1' == sysSupportWorkOrder || roleList['9_6']" title="消息提醒" style="float:right;padding-top:5px;margin-right:20px;cursor:pointer" @click="noticeFlag = true">
             <Badge :count="Number(unreadCnt.cnt ? (unreadCnt.cnt < 0 ? 0 : unreadCnt.cnt ) :0)" overflow-count="99" :offset="[6,3]">
                <Icon type="ios-notifications-outline" size="30" color="#008eff"></Icon>
            </Badge>
        </div>
        <!--<Dropdown title="在线聊天信息">-->
        <!--<Badge :count="infoNumber">-->
        <!--<div class="right_img_div"><img src="../../assets/image/infoBlue.png" style="width: 18px;height: 12px;margin-top: 16px"/></div>-->
        <!--</Badge>-->
        <!--<DropdownMenu slot="list">-->
        <!--<DropdownItem v-for="(item,index) in infoList" :key="index">{{item.value}}</DropdownItem>-->
        <!--</DropdownMenu>-->
        <!--</Dropdown>-->
        <!--<Dropdown title="公告">-->
        <!--<Badge :count="noticeNumber">-->
        <!--<div class="right_img_div"><img src="../../assets/image/noticeBlue.png" style="width: 20px;height: 20px;margin-top: 11px"/></div>-->
        <!--</Badge>-->
        <!--<DropdownMenu slot="list">-->
        <!--<DropdownItem v-for="(item,index) in noticeList" :key="index">{{item.value}}</DropdownItem>-->
        <!--</DropdownMenu>-->
        <!--</Dropdown>-->
        <!--<Dropdown title="待处理任务">-->
        <!--<Badge :count="processNumber">-->
        <!--<div class="right_img_div"><img src="../../assets/image/processBlue.png" style="width: 16px;height: 20px;margin-top: 11px;"/></div>-->
        <!--</Badge>-->
        <!--<DropdownMenu slot="list">-->
        <!--<DropdownItem v-for="(item,index) in processList" :key="index">{{item.value}}</DropdownItem>-->
        <!--</DropdownMenu>-->
        <!--</Dropdown>-->
    </div>
    <div v-if="'0' == agentInfo.employeeType" class="agent_status_style">
        <Select v-model="agentStatus" style="width:100px" :disabled="disabled" @on-change="handleStatus" @on-open-change="openStatus">
            <Option v-for="(item,index) in agentStatusList" v-show="item.id != '8' || (item.id == '8' && '2' != agentInfo.isSupportChat)" :value="item.id" :key="index">{{ item.name}}</Option>
        </Select>
        <span>{{hour<10?"0"+hour:hour}}:{{minute<10?"0"+minute:minute}}:{{second<10?"0"+second:second}}</span>
    </div>
    <a id="agent_status_change" style="display: none"></a>
    <el-drawer title="来电通知" :visible.sync="showIncoming" :show-close="false" :direction="direction" class="answer_cancel" :modal="false" :wrapperClosable="false" :style="maskHeight">
        <el-button type="success" icon="el-icon-phone-outline" @click="answerOrCancel(true)">接听</el-button>
        <el-button type="danger" icon="el-icon-phone" @click="answerOrCancel(false)" :disabled="phoneType=='0' || phoneType=='4'" style="margin-left: 29px;">挂断</el-button>
    </el-drawer>
    <!-- 提醒界面 -->
    <el-drawer size="22%" :style="screenHeight" :modal-append-to-body="false" :visible.sync="noticeFlag" :with-header="false" :modal="false">
        <Spin size="large" fix v-if="spinNoticeShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
        <div class="remind" style="float: left;width: 94%;margin-left: 10px;">
            <el-tabs v-model="activeName" :stretch="true">
                <el-tab-pane :label="'通知('+Number(unreadCnt.cnt ? (unreadCnt.cnt < 0 ? 0 : unreadCnt.cnt ) :0)+')'" name="1">
                    <div class="cuslist" :style="tableHeight">
                        <ul class="listul" >
                            <li class="listli" v-for="(item, index) in noticeInfos" :key="index" @click="clickNotice(item.msgFrom,item.uuid,item.topic,item.sessionChannel,item)">
                                <div class="firstCE">
                                    <div class="channel" >
                                        <img title="网页咨询" v-if="item.sessionChannel == '-7' || item.sessionChannel == '-23'" src="@/assets/image/online/pcicon.png"/>
                                        <img title="微信咨询" v-if="item.sessionChannel == '-8' || item.sessionChannel == '-24'" src="@/assets/image/online/WeChaticon.png"/>
                                        <img title="小程序咨询" v-if="item.sessionChannel == '-9' || item.sessionChannel == '-25'" src="@/assets/image/online/Appletsicon.png"/>
                                        <img title="电话咨询" v-if="item.sessionChannel == '-22'" src="@/assets/image/phone.png"/>
                                        <img title="公告" v-if="item.sessionChannel == 'Notice'" src="@/assets/image/online/notice.png"/>
                                    </div>
                                    <div class="cusdialog">
                                        <div class="cusname">{{item.name}}</div>
                                          <Badge v-if="item.msgFrom == 'chatOnLine'" :count="Number(item.unreadCnt)" :overflow-count="99" class="tips"></Badge>
                                          <div class="dialogrig">{{item.topic}}</div>
                                    </div>
                                </div>
                                <div class="custext"><b>{{item.lastMsg}}</b></div>
                                <div class="lastfloor">
                                    <p class="lasttime">{{item.lastTime}}</p>
                                </div>
                            </li>
                        </ul>
                    </div> 
                </el-tab-pane>
                <el-tab-pane label="公告" name="2">
                    <div class="cuslist" :style="tableHeight">
                        <ul class="listul" >
                            <li class="listli" v-for="(item, index) in noticeTable" :key="index" @click="clicknoticeTable(item)">
                                <div class="firstCE">
                                    <div class="channel" >
                                        <img title="公告" src="@/assets/image/online/notice.png"/>
                                    </div>
                                    <div class="cusdialog">
                                        <div class="cusname">{{item.title}}</div>
                                    </div>
                                </div>
                                <!-- <div class="custext"><b>{{item.lastMsg}}</b></div> -->
                                <div class="lastfloor">
                                    <p class="lasttime">{{item.updateTime}}</p>
                                </div>
                            </li>
                        </ul>
                    </div> 
                </el-tab-pane>
            </el-tabs>
        </div>
        <div style="float: left;margin-top: 3%;margin-left: -10%;">
            <Icon type="ios-trash" size="24" style="float:right" @click="clearMsg"/>
        </div>
    </el-drawer>
    <!-- 未绑定分机 -->
    <Modal
        v-model="showSetExtension"
        title="设置分机"
        width='350px' 
        footer-hide
        :mask-closable='false'>
       坐席分机： <el-select v-model="extension" filterable placeholder="请选择分机" style="margin-bottom: 15px;">
            <el-option
              v-for="item in ExtensionList"
              :key="item.agentExten"
              :label="item.agentExten"
              :value="item.agentExten">
            </el-option>
        </el-select>
        <br/>
        <Button type="primary" class="submit_btn" @click="SetExtension()" style="margin-left: 20%;">确认</Button>
        <Button type="error"   class="cancel_btn" @click="showSetExtension=false" style="margin-left: 20%;">取消</Button>
    </Modal>
    <dialerPage @closeDialerPage="closeDialerPage" :showDialer="showDialer" @closedtmf="closedtmf"></dialerPage>
    <MultipartyPop :showMultiparty="showMultiparty"  @closeMultiparty="closeMultiparty" :meetingroomList="meetingroomList" ></MultipartyPop><!-- 多方会议管理弹窗 -->
    <transferPage @closeTransferPage="closeTransferPage" :showTransfer="showTransfer" :transferType="transferType"></transferPage>
    <ViewknowContentPop :openDataKnlgPop="openDataKnlgPop" :contentId="contentId" @closeknowContentPop="closeknowContentPop"></ViewknowContentPop>
    <PersonKnowPop :openPersonKnowPop="openPersonKnowPop" :personId="personId" @closePersonKnowPop="closePersonKnowPop"></PersonKnowPop>
    <internalCallScreen @closeInternal="closeInternal" :showInternalCall="showInternalCall"></internalCallScreen>
    <SeeNotice :showSeeNotice="showSeeNotice" :notice="noticeJson" @closeNotice="closeNotice"></SeeNotice>


</div>
</template>

<script>
import dialerPage from '@/components/loginHeadMange/DialerPage.vue'
import {
    publicFunClass
} from '@/components/js/PublicFunClass.js'
//引用多方会议管理
import MultipartyPop from '@/components/loginHeadMange/MultipartyPop.vue'
import ViewknowContentPop from '@/components/knowledgeBase/ViewknowContentPop.vue'
import PersonKnowPop from '@/components/knowledgeBase/PersonKnowPop.vue'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import transferPage from '@/components/loginHeadMange/TransferPage.vue'
import internalCallScreen from '@/components/loginHeadMange/InternalCallScreenPop.vue'
import telephoneScreen from '@/components/loginHeadMange/TelephoneScreen.vue'
import {MqService} from '@/components/js/ChatService.js';
import SeeNotice from '@/components/userManagement/SeeNotice.vue'

export default {
    name: "StandardSysHeadShow",
    mixins: [publicFunClass,MqService],
    components: {
        //多方会议
        MultipartyPop,
        dialerPage,
        ViewknowContentPop,
        PersonKnowPop,
        Treeselect,
        transferPage,
        internalCallScreen,
        telephoneScreen,
        SeeNotice
    },
    data() {
        return {
            newAgentPassword:'',
            spinNoticeShow:false,
            roleList: JSON.parse(localStorage.getItem("roleList")),
            showSeeNotice:false,
            noticeJson:'',
            noticeTable:[],
            activeName:'1',
            isSetExten:false,
            extension:'',
            ExtensionList:[],
            showSetExtension:false,

            second: 0,
            hour: 0,
            minute: 0,
            timeMount: "",
            loginName: localStorage.getItem("loginName"),
            phone: '1',
            phoneStatus: [{
                'id': '1',
                'name': '外置'
            }],
            handle: '1',
            handleList: [{
                'id': '1',
                'name': '8秒'
            }],
            currentName: '1',
            currentNameList: [{
                'id': '1',
                'name': '正常'
            }],
            infoNumber: 69,
            infoList: [{
                'id': '1',
                'value': '802座席在吗'
            }, {
                'id': '2',
                'value': '810座席在吗'
            }],
            noticeNumber: 6,
            noticeList: [{
                'id': '1',
                'value': '元旦放假通知'
            }, {
                'id': '2',
                'value': '明天放假通知'
            }],
            processNumber: 6,
            processList: [],
            checkInOrOutText: "签入",
            checkOutSign: '0',
            companyCode: localStorage.getItem("companyId"),
            username: localStorage.getItem("loginName"),
            historyAgentStatus: '0',
            agentStatus: '-1',
            historyStatus: '-1',
            agentStatusList: [{
                'id': '-1',
                'name': '离线'
            }, {
                'id': '0',
                'name': '空闲'
            }, {
                'id': '1',
                'name': '振铃'
            }, {
                'id': '2',
                'name': '通话'
            }, {
                'id': '3',
                'name': '保持'
            }, {
                'id': '4',
                'name': '后处理'
            }, {
                'id': '5',
                'name': '被占用'
            }, {
                'id': '6',
                'name': '忙碌'
            }, {
                'id': '7',
                'name': '离开'
            }, {
                'id': '8',
                'name': '仅呼出'
            }],
            employeeHead: './static/img/customerService.2f81c4b.png',
            pingicon: require('../../assets/image/signal0.png'),
            disabled: true,
            showDialer: false,
            showInternalCall: false,
            callType: '2',//所在通话的通话类型
            showTransfer: false,
            transferType: 'cancel',
            showIncoming: false,
            direction: 'btt',
            opacity1: false,
            opacity3: true,
            opacity4: true,
            opacity5: true,
            opacity6: true,
            opacity7: true,
            opacity8: true,
            opacity9: true,
            opacity10: true,
            opacity11: true,
            opacity12: true,
            opacityChat: true, //在线客服
            subscribeId: '',
            topic: '',
            closeHeart: '0',
            method: 'signin',
            callPhone: 0, //弹屏号码
            agentExten: '',
            agentNumber: '',
            agentPassword: '',
            // client: this.Stomp.client(this.MQTT_SERVICE),
            outCount: 0,
            outgoingSession: null,
            incomingSession: null,
            currentSession: null,
            constraints: {
                audio: true,
                video: {
                    faceMode: 'user'
                }
            },
            localStream: null,
            userAgent: null,
            //知识库后期新增
            tabsName: '1',
            search: '',
            value: '',
            content: '',
            screenHeight: {
                height: ''
            },
            maskHeight: {
                marginLeft: ''
            },
            personId: '',
            inspectTreeData: [],
            openPersonKnowPop: false,
            contentId: '',
            openDataKnlgPop: false,
            infoTableList: [],
            selectedTreeId: '0',
            drawer: false,
            isCollect: '',
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
            loseHeartbeat: 0,
            customerPhoneFlag: false, //是否呼入或呼出电话，只有这些电话有满意度、转接、询问、三方
            askPhoneFlag: false,
            threewayFlag: false,
            incomingCallAudio: new Audio('./static/sounds/incoming-call-ringtone.wav'),//铃声
            hangupAudio: new Audio('./static/sounds/hanguptone.wav'),
            remoteAudio: new Audio(),
            calloutFlag: '0', //是否呼出电话，判断自动接听
            hangupAgentStatus: '', //挂断后状态,
            reconnectionCount: '',//重连标识
            phoneType: "1", //话机类型 0-外置电话 1-内置 2-内置呼出自动接听 3-内置全部自动接听,4-外置话机自动接听。不启用webrtc，设置为0,
            // ping
            objIMG: {},
            startTime: 0,
            endTime: 0,
            currentUrl: '',
            fastIp: {
                "ip": '',
                "delay": 0
            },
            pingDelays: [],
            intervalFlag: 0,
            timeoutFlag: [],
            pingAvg: 0, //ping平均值
            pingRate: 0, //丢包率
            pingNum: 0, //发出的包数
            receNum: 0, //未接收的包数
            nextPingUrl: '', //下一个需要ping的url
            proxyList: [], //可以注册proxy列表
            sipSocket: null, //
            normalSignOut: false,//正常签出
            signalShow:false,//信号图标是否显示
            forceSignOut: false, //强制签出，用于doAgentStatus接口
            haveAi:"",
            haveVideo:"",
            showMultiparty:false,//多方会议管理弹窗是否显示
           // meetingroomList:[{'number':'0002','jointime':'0','statu':'已接通','memberID':'1','silence':true,'remove':true,'unmute':false,'reinvite':false},{'number':'0003','jointime':'0','statu':'已接通','memberID':'2','silence':true,'remove':true,'unmute':false,'reinvite':false}],
           meetingroomList:[], //会议室成员列表
           duofanging:false,
           createdmeeting:false,
           agentInfo: JSON.parse(localStorage.getItem("agentInfo")),
            companyType:localStorage.getItem("companyType"),
            sysping:"网络延迟",
            statusTimeOut:'',
            skillgroup:'',
           // SkillList:[{"waitNum":"0","queueName":"default","companyNo":"1000","agentIds":"2"},{"waitNum":"2","queueName":"gw001","companyNo":"1000","agentIds":"2"}],
            SkillList:[],
            queuelength:"",
            agentId:localStorage.getItem("agentId"),
            eventdata:[],
            skillshow:false,
            internalFlag:'0',
            unreadCnt: this.$store.getters.getUnreadMsgCnt(),
            showChat: false,  //在线客服的隐藏
            token:localStorage.getItem("token"),
            isScreen:false,
            useIp:'',
            timOutTimer:'',
            timeForVideo:'',
            sysSupportWorkOrder: JSON.parse(localStorage.getItem("sysSupportWorkOrder")),
            valueDate:'',
            keepAlive:'',
            isHandsOut:'0',
            connectTimeOut:'',
            isConnectMq:false,
            divWidth:{'width': '','overflow':'hidden','line-height': '40px','maxWidth':''},
            noticeFlag: false, //提醒标识
            noticeInfos:[],
            tableHeight:{'height': ''},
            knowTabsFlag: 'first', //知识库tab选项标识
        }
    },
    methods: {
        clicknoticeTable(item){
            this.noticeJson=JSON.stringify(item);
            this.showSeeNotice=true;
        },
        closeNotice:function(){
            this.showSeeNotice=false;
        },
        initNotice:function(){
            let that=this;
            let param={
              isPublishId:this.agentInfo.employeeId,
            };
            this.spinNoticeShow=true;
            this.$http.post("notice/toIndex.json",param) .then(function (res) {
                that.spinNoticeShow=false;
              let result=res.data;
              if(result.flag!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.noticeTable=result.obj.list;
            })
        },
        skillchange:function(event){
            let jack = this.SkillList.find(function(obj){
            return obj.queueName == event;
            })
             if(!jack){
                this.queuelength=0;
             }else{
                this.queuelength=jack.waitNum;
             }
        },
        //显示多方会议管理弹窗
        appearMultiparty:function () {
                    if(this.createdmeeting==false){
                            let message = "{'method':'conf_create','agentno':'" + this.agentNumber + "','companyCode':'" + this.companyCode + "','timestamp':'"+ new Date()+ "' }";
                            this.sendMessage(message);
                    }
                    this.initBtnOpacity(true, true, false, false, false, true,true,true, false, true);
                    this.showMultiparty=true;
                    window.hideAiAndVideo();
        },
        //关闭多方会议管理弹窗
        closeMultiparty:function(type,surenumber){
             if (type == "cancel") {
                this.showMultiparty=false;
                return false;
            }
            if (type == 'endmeeting') { //结束会议
                let message = "{'companyCode':'" + this.companyCode + "','method':'conf_stop','agentno':'" + this.agentNumber  + "','timestamp':'"+ new Date()+ "' }";
                this.sendMessage(message);
                this.showMultiparty=false;
                this.showInvitepage=false;
                this.disabled = false;
                this.initBtnOpacity(false, false, true, true, true, true, true, true, true, true);
            }
            //邀请参加会议
            if(type == 'invitee'){
                //alert("cccccc"+surenumber);
                 let message = "{'companyCode':'" + this.companyCode + "','method':'conf_invite','agentno':'" + this.agentNumber + "','callee':'" + surenumber + "','pstnnumber':'" + localStorage.getItem("pstnNumber") + "','timestamp':'"+ new Date()+ "' }";
                this.sendMessage(message);
            }
            //静音
            if(type == 'mute'){
                // alert("cccccc");
                 let message = "{'companyCode':'" + this.companyCode + "','method':'conf_mute','agentno':'" + this.agentNumber + "','param2':'" + surenumber + "','timestamp':'"+ new Date()+ "' }";
                this.sendMessage(message);
            }

            //取消静音
            if(type == 'unmute'){
                // alert("cccccc");
                 let message = "{'companyCode':'" + this.companyCode + "','method':'conf_unmute','agentno':'" + this.agentNumber + "','param2':'" + surenumber  + "','timestamp':'"+ new Date()+ "' }";
                this.sendMessage(message);
            }

            //移除
            if(type == 'kickoff'){
                // alert("cccccc");
                 let message = "{'companyCode':'" + this.companyCode + "','method':'conf_kickoff','agentno':'" + this.agentNumber + "','param2':'" + surenumber  + "','timestamp':'"+ new Date()+ "' }";
                this.sendMessage(message);
            }

        },
        setToolbarByStatus: function (state) {
            if (state == "-1") { //离线
                this.disabled = true;//禁用
                this.initBtnOpacity(true, true, true, true, true, true, true, true, true, true, true);//从内呼开始
            }
            if (state == "0") { //空闲
                this.customerPhoneFlag = false;
                this.askPhoneFlag = false;
                this.duofanging = false;  //空闲才能接打电话，当状态为空闲时，duofanging设置为false
                this.disabled = false;
                this.initBtnOpacity(false, false, true, true, true, true, true, true, true, true,false);
            }
            if (state == "1") { //振铃
                let status = localStorage.getItem("hangupAgentStatus");
                if (this.hangupAgentStatus != status) {
                    this.hangupAgentStatus = status;
                    if (status == '' || status == '0') {
                        status = '1';
                    } else if (status == '8') {
                        status = '2';
                    }else {
                        status = '0';
                    }
                    let message = "{'method':'set_acs_type','agentno':'" + this.agentNumber + "','agentstatus':'" + status + "','companyCode':'" + this.companyCode  + "','timestamp':'"+ new Date()+ "' }";
                    this.sendMessage(message);
                }
                this.disabled = true;
                this.initBtnOpacity(true, true, true, true, true, true, true, true, true, true,false);
            }
            if(state == "9") { //客户振铃
                this.initBtnOpacity(true, true, false, true, true, true, true, true, true, true,false);
            }
             if(state == "10") { //客户接通
                this.initBtnOpacity(true, true, false, false, false, true, false, false, false, true,false);
            }
            if (state == "2") { //通话

                this.disabled = true;
                if (this.customerPhoneFlag) {
                    this.initBtnOpacity(true, true, false, false, false, true, false, false, false, true,false);
                } else {
                    this.initBtnOpacity(true, true, false, true, false, true, true, true, true, true,false);
                }
            }
            if (state == "3") { //保持
                this.disabled = true;
                this.initBtnOpacity(true, true, true, true, true, false, true, true, true, true,false);
            }
            if (state == "4") { //后处理
                this.customerPhoneFlag = false;
                this.askPhoneFlag = false;
                this.disabled = false;
                this.initBtnOpacity(true, true, true, true, true, true, true, true, true, true,false);
                let afterDoTime = this.configInfo.afterDoTime;

                // 后处理
                if (afterDoTime > 0) {
                    let that = this;
                    that.statusTimeOut = setTimeout(function () {
                    let message = "{'method':'change_status','agentno':'" + that.agentNumber + "','password':'" + that.agentPassword + "','exten':'" + that.agentExten + "','agentstatus':'0','pstnnumber':'" + localStorage.getItem("pstnNumber") + "','companyCode':'" + that.companyCode + "','timestamp':'"+ new Date()+ "' }";
                     that.sendMessage(message);
                    }, afterDoTime * 1000);
                }
            }
            if (state == "5") { //被占用
                this.disabled = true;
                this.initBtnOpacity(true, true, true, true, true, true, true, true, true, true,false);
            }
            if (state == "6") { //忙碌
                this.disabled = false;
                this.initBtnOpacity(true, true, true, true, true, true, true, true, true, true,false);
            }
            if (state == "7") { //离开
                this.disabled = false;
                this.initBtnOpacity(true, true, true, true, true, true, true, true, true, true,false);
            }
            if (state == "8") { //仅呼出
                this.customerPhoneFlag = false;
                this.askPhoneFlag = false;
                this.disabled = false;
                this.initBtnOpacity(false, false, true, true, true, true, true, true, true, true,false);
            }

        },
        handleStatus: function (agentStatus) {
            if (undefined == this.agentStatus || '' == this.agentStatus) {
                this.agentStatus = "-1";
	          }
            if("4" != this.agentStatus){
              clearTimeout(this.statusTimeOut);
            }
            console.info("由于右上角的状态发生改变，触发动作改变状态后："+this.agentStatus);
            let message = "{'method':'change_status','agentno':'" + this.agentNumber + "','password':'" + this.agentPassword + "','exten':'" + this.agentExten + "','agentstatus':'" + this.agentStatus + "','pstnnumber':'" + localStorage.getItem("pstnNumber") + "','companyCode':'" + this.companyCode + "','timestamp':'"+ new Date()+ "' }";
            this.sendMessage(message);
        },
        openStatus: function (flag) {
            let list = [{
                'id': '-1',
                'name': '离线'
            }, {
                'id': '0',
                'name': '空闲'
            }, {
                'id': '1',
                'name': '振铃'
            }, {
                'id': '2',
                'name': '通话'
            }, {
                'id': '3',
                'name': '保持'
            }, {
                'id': '4',
                'name': '后处理'
            }, {
                'id': '5',
                'name': '被占用'
            }, {
                'id': '6',
                'name': '忙碌'
            }, {
                'id': '7',
                'name': '离开'
            }, {
                'id': '8',
                'name': '仅呼出'
            }];
            this.agentStatusList = [{
                'id': '0',
                'name': '空闲'
            }, {
                'id': '6',
                'name': '忙碌'
            }, {
                'id': '8',
                'name': '仅呼出'
            }];
            if (flag) {
                this.historyAgentStatus = this.agentStatus;
            }
            if (this.historyAgentStatus != "0" && this.historyAgentStatus != "6" && this.historyAgentStatus != "8") {
                for (let i = 0; i < list.length; i++) {
                    if (this.historyAgentStatus == list[i].id) {
                        this.agentStatusList.push(list[i]);
                    }
                }
                if (!this.agentStatus) {
                    this.agentStatus = this.historyAgentStatus;
                }
            }
        },
        //心跳监监测
        heartbeatFun: function () {
            let that = this;
            if (!this.mqClient.connected) {
                this.closeHeart = "0";
            }
            if (this.closeHeart == "1") {

                let message = "{'method':'heartbeat','callee':'" + this.callPhone + "','agentno':'" + this.agentNumber + "','password':'" + this.agentPassword + "','exten':'" + this.agentExten + "','agentstatus':'0','pstnnumber':'" + localStorage.getItem("pstnNumber") + "','companyCode':'" + this.companyCode + "','timestamp':'"+ new Date()+ "' }";

                this.mqClient.send("/queue/mpccReceiver", {
                    "content-type": "text/plain",
                    "x-message-ttl": "30000"
                }, message);
                that.loseHeartbeat = that.loseHeartbeat + 1;
                if(that.loseHeartbeat >=4){
                    console.log("心跳超时,座席即将重连...");
                    // 心跳超时，会受到disconnect命令，在命令中执行重连
                    console.log("reconnectionCount:"+that.reconnectionCount);
                    console.log("loseHeartbeat:"+that.loseHeartbeat);
                    if(!that.reconnectionCount){
                        that.reconnectionCount = setInterval(function(){
                            that.reconnection();
                        },30000)
                    }
                    return false;
                }
                setTimeout(function(){
                    that.heartbeatFun()
                },10000);
            }
        },
        getTime: function () {
            clearInterval(this.timeMount);
            let second = this.second + 1;
            let minute = this.minute;
            let hour = this.hour;
            if (second >= 60) {
                second = 0;
                minute = minute + 1;
            }
            if (minute >= 60) {
                minute = 0;
                hour = hour + 1;
            }
            this.second = second;
            this.minute = minute;
            this.hour = hour;
            let that = this;
            this.timeMount = setInterval(() => {
                that.getTime();
            }, 1000);
        },
        onEvent: function (frame) {
            let object = JSON.parse(frame.body);
            let that = this;
            let retCode = object.retCode;
            let reason = object.reason;
            let eventMethod = object.method;
            let status = object.status;
            let eventType = object.type;
            let eventAgent = object.agentno;
            let eventMessage = object.retMessage;
            if (eventMethod == "get_customer_of_queue") { //获取技能组监控信息
                this.$emit("monitorData", frame.body);
            }
            if (eventMethod == "get_agents_monitor_info") { //获取所有座席监控信息
                this.$emit("seatMonitorData", frame.body);
            }
            if(eventType == 'pushSkillGroupEvent'){
                let newlista=[];
                let newa=[];
                that.eventdata=object.data;
                let matchid =that.eventdata.filter(function(item){
                    return item.agentIds.split(",").indexOf(that.agentId) > -1; //前面数组的id 后面登录获取到的id
                })
                that.SkillList=matchid;
                if(that.skillgroup==""&&that.queuelength==""){
                    if(matchid && matchid.length > 0 && matchid[0].queueName){
                      that.skillgroup=matchid[0].queueName;
                      that.queuelength=matchid[0].waitNum;
                    }
                }
                if('签出' == this.checkInOrOutText){
                  this.skillshow=true;
                }
                this.skillchange(this.skillgroup);
            }
            if (eventType == 'event') {
                if (eventMethod == "signin") {
                    this.opacity1 = false;
                    this.$Loading.finish();
                    if (retCode == "0") {
                        this.closeHeart = "1";
                        if (this.checkInOrOutText != "签出") {
                            this.$Message.info("签入成功");
                            clearInterval(this.connectTimeOut);
                            this.connectTimeOut = "";
                            this.signalShow = true;
                            clearInterval(this.reconnectionCount);
                            this.reconnectionCount = "";
                            localStorage.setItem("signinStatus", "1");
                            this.loseHeartbeat = 0;
                            // 签入成功，10s后开始发送心跳
                            setTimeout(function () {
                                that.heartbeatFun();
                            }, 10*1000);

                            // 10s一次ping
                            if(that.intervalFlag){
                                clearInterval(that.intervalFlag);  //清除已经存在的ping
                            }
                            if (that.phoneType != "0" && that.phoneType != '4') { //内置电话
                                that.changePingIcon(that.fastIp.delay, 100);
                                that.pingNum = 0;
                                that.intervalFlag = setInterval(function () {
                                    that.pingFor();
                                }, 10*1000);
                            }
                            that.normalSignOut = false;
                            that.forceSignOut = false;
                            this.setToolbarByStatus("0");
                            // 签入成功，获取在线客服消息
                            that.getOnlineMsg();
                        }
                        this.disabled = false;
                        this.checkInOrOutText = "签出";
                        this.opacity3 = false;
                        this.opacity4 = false;
                        this.opacityChat = false;  //在线客服可点击
                        //0：挂断为后处理 1：挂断为空闲 2：挂断为仅呼出
                        let status = localStorage.getItem("hangupAgentStatus");
                        this.hangupAgentStatus = status;
                        if (status == '' || status == '0') {
                            status = '1';
                        } else if (status == '8') {
                            status = '2';
                        } else {
                            status = '0';
                        }
                        let message = "{'method':'set_acs_type','agentno':'" + this.agentNumber + "','agentstatus':'" + status + "','companyCode':'" + this.companyCode + "','timestamp':'"+ new Date()+ "' }";
                        this.sendMessage(message);
                    }else{
                        // 签入失败
                        this.opacity1 = false;
                        this.$Loading.finish();
                        this.second = 0;
                        this.hour = 0;
                        this.minute = 0;
                        this.outCount = 0;
                        this.disabled = true;
                        clearInterval(this.timeMount);

                        this.agentStatus = "-1";
                        this.unRegested();
                         this.showMultiparty=false;
                        localStorage.setItem("signinStatus", "0");
                        this.closeHeart = "0";
                        this.$Message.info("签入失败");
                        this.signalShow = false;
                        this.skillshow=false;
                        this.skillshow=false;
                        this.checkOutSign = "0";
                        that.pingicon = require('../../assets/image/signal0.png');
                        // 签出成功，清除ping
                        clearInterval(that.intervalFlag);
                        that.normalSignOut = false;
                        that.forceSignOut = false;

                        this.checkInOrOutText = "签入";
                        this.setToolbarByStatus("-1");
                    }
                } else if (eventMethod == "signout") {
                    if(reason == "3"){
                      that.$Modal.info({
                        title:'提示',
                        content:"当前座席号已在其他地方签入，请确认后继续操作"
                      });
                    }
                    this.opacity1 = false;
                    this.$Loading.finish();
                    this.second = 0;
                    this.hour = 0;
                    this.minute = 0;
                    this.outCount = 0;
                    this.disabled = true;

                    clearInterval(this.timeMount);

                    this.agentStatus = "-1";
                    this.unRegested();
                     this.showMultiparty=false;
                    localStorage.setItem("signinStatus", "0");
                    clearInterval(this.reconnectionCount);
                    this.reconnectionCount = "";

                    this.closeHeart = "0";
                    // this.disconnect();
                    if (eventMethod == "signout" && !that.forceSignOut) {

                        this.$Message.info("签出成功");
                        this.signalShow = false;
                        this.skillshow=false;
                        this.skillshow=false;
                        this.checkOutSign = "0";
                        that.pingicon = require('../../assets/image/signal0.png');
                        // 签出成功，清除ping
                        clearInterval(that.intervalFlag);
                        that.normalSignOut = false;
                        that.forceSignOut = false;
                        that.getTime();

                        this.removeOnlineMsg();
                    }

                    this.checkInOrOutText = "签入";
                    this.setToolbarByStatus("-1");
                } else if (eventMethod == "disconnect") {
                  if((eventMessage.indexOf("signout") != -1 && eventMessage.indexOf("common") != -1) || eventMessage.indexOf("kicked out") != -1){
                    return false;
                  }
                  if((eventMessage.indexOf("other") != -1 && eventMessage.indexOf("agent") != -1)){
                    console.info("被别的座席强制下线");
                    return false;
                  }
                  if(this.checkInOrOutText == "签入"){
                      return false;
                  }
                  // 重新连接
                  if (this.subscribeId) {
                    this.mqClient.unsubscribe(this.subscribeId);
                    // this.mqClient.disconnect();
                    this.subscribeId = "";
                  }
                  this.opacity1 = false;
                    this.$Loading.finish();
                    this.second = 0;
                    this.hour = 0;
                    this.minute = 0;
                    this.outCount = 0;
                    this.disabled = true;
                    this.signalShow = false;
                    this.skillshow=false;
                        that.pingicon = require('../../assets/image/signal0.png');
                        // 签出成功，清除ping
                        clearInterval(that.intervalFlag);
                        that.normalSignOut = false;
                        that.forceSignOut = false;

                    clearInterval(this.timeMount);
                    this.checkInOrOutText = "签入";
                    this.agentStatus = "-1";
                    this.setToolbarByStatus("-1");
                    clearInterval(this.reconnectionCount);
                    // 心跳超时，异常断开重连
                    if(!this.reconnectionCount){
                        console.info("收到Disconnect事件，异常断开重连");
                        let that = this;
                        this.reconnectionCount = setInterval(function () {
                            that.reconnection();
                        }, 30000);
                    }

                    this.removeOnlineMsg();
                } else if (eventMethod == "agent_status_change" || eventMethod == "manual_callout_customer_ring" || eventMethod == "manual_callout_customer_answer") { //座席状态被改变
                    if (eventAgent == this.agentNumber) {
                        this.agentStatusList = [{'id': '0','name': '空闲'}, {'id': '6','name': '忙碌'}, {'id': '8','name': '仅呼出'}];
                        let list = [{'id': '-1','name': '离线'}, {'id': '0','name': '空闲'}, {'id': '1','name': '振铃'},
                        {'id': '2','name': '通话'}, {'id': '3','name': '保持'}, {'id': '4','name': '后处理'}, {'id': '5','name': '被占用'},
                        {'id': '6','name': '忙碌'}, {'id': '7','name': '离开'}, {'id': '8','name': '仅呼出'}, {'id': '9','name': '客户振铃'}
                        , {'id': '10','name': '客户接通'}];
                        if (status != "0" && status != "6" && status != "8") {
                            for (let i = 0; i < list.length; i++) {
                                if (status == list[i].id) {
                                    this.agentStatusList.push(list[i]);
                                }
                            }
                        }
                        document.getElementById("agent_status_change").click();
                        if(this.internalFlag == '1' && status != "1" && status != "2"){
                          this.internalFlag = '0';
                        }
                        this.historyStatus = status;
                        this.setToolbarByStatus(status);
                        this.agentStatus = status;
                        this.second = 0;
                        this.hour = 0;
                        this.minute = 0;
                        this.getTime();
                        if(status != "1"){
                          this.showIncoming = false;
                        }
                        if(status == "0"){
                          this.isScreen = false;
                        }
                        if(status == "1"){
                        let outPhonePick=localStorage.getItem("outPhonePick");
                        let phoneType=localStorage.getItem("phoneType");
                        setTimeout(function () {
                            if((phoneType == '0' || phoneType == '4') && '1' == outPhonePick){
                              that.showIncoming = true;
                            }
                            if(phoneType == '4' && that.callType == '0'){
                              that.showIncoming = false;
                              let message = "{'method':'pickup','agentno':'" + that.agentNumber + "','companyCode':'" + that.companyCode + "','timestamp':'"+ new Date()+ "' }";
                              that.sendMessage(message);
                            }
                            if(phoneType == '4' && that.callType == '1'){
                              that.showIncoming = false;
                              let message = "{'method':'pickup','agentno':'" + that.agentNumber + "','companyCode':'" + that.companyCode + "','timestamp':'"+ new Date()+ "' }";
                              that.sendMessage(message);
                            }
                          }, 2000);
                        }
                    }
                } else if (eventMethod == "common_callin_bridge_ring") { //呼入弹屏

                // 弹屏第一步：呼入弹屏
                    if (eventAgent == this.agentNumber) {
                        this.isScreen = true;
                        this.calloutFlag = '0';
                        this.customerPhoneFlag = true;
                        let customerNum = object.customerNum;
                        let callInPhone = customerNum;
                        let agentUuid = object.agentUuid;
                        let phoneIsHide = this.configInfo.phoneIsHide;
                        localStorage.setItem("saveScreenPhone_" + agentUuid, customerNum);
                        if (phoneIsHide == '1' && customerNum.length >= 11) {
                            customerNum = customerNum.substring(0, customerNum.length - 8) + "****" + customerNum.substring(customerNum.length - 4, customerNum.length)
                        }

                        let reserve = object.reserve;
                        let ivrCallLegId = object.ivrCallLegId
                        let custUuid = object.custUuid
                        let originalCustUuid = object.originalCustUuid
                      let reserveObj = {
                            phoneUUid: "pop_"+callInPhone,
                            callPhone : callInPhone,
                            callPhoneHide : customerNum,
                            callUuid: agentUuid,
                            agentNumber: eventAgent,
                            companyCode: this.companyCode,
                            callcenterNum: object.callcenterNum,
                            reserve: reserve ? reserve : '',
                            ivrCallLegId: ivrCallLegId ? ivrCallLegId : '',
                            custUuid: custUuid ? custUuid : '',
                            originalCustUuid : originalCustUuid ? originalCustUuid : ''
                        }

                        this.$emit("dialer", reserveObj.phoneUUid + "," + customerNum + ","+agentUuid, reserveObj);
                        let that = this;
                        that.timeForVideo = setTimeout(function () {
                                if(that.haveVideo == '1'){
                                    telephoneScreen.methods.initAgentVideo();
                                }
                        }, 2000);
                      window.refresh(callInPhone);
                    }

                } else if (eventMethod == "manual_callout_agent_ring") { //呼出弹屏
                // 弹屏第一步：呼出弹屏
                    if (eventAgent == this.agentNumber) {
                        this.isScreen = true;
                        this.calloutFlag = '1';////是否呼出电话，判断自动接听
                        this.customerPhoneFlag = true;////是否呼入或呼出电话，只有这些电话有满意度、转接、询问、三方
                        let customerNum = object.customerNum;//代表呼入的客户号码
                        let callOutPhone = customerNum;
                        let agentUuid = object.agentUuid;//代表座席工号
                        let phoneIsHide = this.configInfo.phoneIsHide;
                        localStorage.setItem("saveScreenPhone_" + agentUuid, customerNum);
                        if (phoneIsHide == '1' && customerNum.length >= 11) {
                            customerNum = customerNum.substring(0, customerNum.length - 8) + "****" + customerNum.substring(customerNum.length - 4, customerNum.length)
                        }

                        let reserveObj = {
                            phoneUUid: "pop_"+callOutPhone,
                            callPhone : callOutPhone,
                            callPhoneHide : customerNum,
                            callUuid: agentUuid,
                            agentNumber: eventAgent,
                            companyCode: this.companyCode
                        }

                        this.$emit("dialer", reserveObj.phoneUUid + "," + customerNum + ","+agentUuid, reserveObj);//StandardSysCombination.vue
                        let that = this;
                        that.timeForVideo = setTimeout(function () {
                          if(localStorage.getItem("phoneType") == "0" || localStorage.getItem("phoneType") == "4"){
                            if(that.haveVideo == '1'){
                              telephoneScreen.methods.initAgentVideo();
                            }
                          }
                        }, 2000);
                      window.refresh(callOutPhone);
                    }
                } else if (eventMethod == "internal_call_called_ring") { //座席被叫振铃
                    if (eventAgent == this.agentNumber) {
                        this.calloutFlag = '0';
                        this.customerPhoneFlag = false;
                        this.internalFlag = '1';
                    }
                } else if (eventMethod == "force_hangup_ring") { //强拆振铃
                    if (eventAgent == this.agentNumber) {
                        this.calloutFlag = '0';
                        this.customerPhoneFlag = true;
                    }
                } else if (eventMethod == "blind_transfer_ring" || eventMethod == "consult_ring") { //座席盲转被叫振铃及弹屏
                    if (eventAgent == this.agentNumber) {
                        this.isScreen = true;
                        this.calloutFlag = '0';
                        this.customerPhoneFlag = true;
                        let customerNum = object.customerNum;
                        let ringPhone = customerNum;
                        let agentUuid = object.agentUuid;
                        let phoneIsHide = this.configInfo.phoneIsHide;
                        localStorage.setItem("saveScreenPhone_" + agentUuid, customerNum);
                        if (phoneIsHide == '1' && customerNum.length >= 11) {
                            customerNum = customerNum.substring(0, customerNum.length - 8) + "****" + customerNum.substring(customerNum.length - 4, customerNum.length)
                        }
                        let reserveObj = {
                            phoneUUid: "pop_"+ringPhone,
                            callPhone : ringPhone,
                            callPhoneHide : customerNum,
                            callUuid: agentUuid,
                            agentNumber: eventAgent,
                            companyCode: this.companyCode,
                            callcenterNum: object.callcenterNum
                        }
                        this.$emit("dialer", reserveObj.phoneUUid + "," + customerNum + ","+agentUuid,reserveObj);
                        let that = this;
                        that.timeForVideo = setTimeout(function () {
                          if(that.haveVideo == '1'){
                            telephoneScreen.methods.initAgentVideo();
                          }
                        }, 2000);
                    }
                }
                else if (eventMethod == "conf_create_result") { //多方创建会议返回
                    if (eventAgent == this.agentNumber) {
                        if (retCode != '0') {
                            this.$Message.info("创建会议失败，" + reason + "");
                            this.showMultiparty=false;
                        }else{
                           // this.meetingroomList=[{'number':this.agentNumber,'jointime':'0','statu':'已接通','memberID':'1','silence':true,'remove':true,'unmute':false,'reinvite':false},{'number':this.callPhone,'jointime':'0','statu':'已接通','memberID':'2','silence':true,'remove':true,'unmute':false,'reinvite':false}], //会议室成员列表
                            this.meetingroomList=[];
                            this.showMultiparty=true;
                            this.duofanging=true;
                            this.createdmeeting=true;
                        }
                    }
                }


                else if (eventMethod == "conference_ring") { //多方被叫振铃
                    if (eventAgent == this.agentNumber) {
                        this.calloutFlag = '0';
                        this.customerPhoneFlag = false;
                    }
                }
                else if (eventMethod == "conf_stop_result") { //多方发送结束命令
                    if (eventAgent == this.agentNumber) {
                        if ("0" === retCode) {
                            this.showMultiparty=false;
                            this.showInvitepage=false;
                            this.meetingroomList=[];
                            this.duofanging=false;
                            this.createdmeeting=false;
                        }else if ("0" != retCode) {
                            this.$Message.info("会议结束失败，" + reason + "");
                        }
                    }
                }
                else if (eventMethod == "conf_destroy") { //多方发送结束命令
                    if (eventAgent == this.agentNumber) {
                            this.showMultiparty=false;
                            this.showInvitepage=false;
                            this.meetingroomList=[];
                            this.duofanging=false;
                             this.createdmeeting=false;
                    }
                }
               else if (eventMethod == "enter_conf") { //多方进入会议
                    if (eventAgent == this.agentNumber) {
                            //判断有无前面已在的人员
                            let memberNum=object.memberNumber;
                            let removestatu;
                            if(memberNum==this.agentNumber){
                                    removestatu=false;
                            }else{
                                removestatu=true;
                            }
                            for(let i=0;i<this.meetingroomList.length;i++){//1遍历meetingroomList
                                if( memberNum==this.meetingroomList[i].number){
                                    this.meetingroomList[i].statu="已接通";
                                    this.meetingroomList[i].memberID=object.memberID;
                                    this.meetingroomList[i].silence=true;
                                    this.meetingroomList[i].remove=removestatu;
                                    this.meetingroomList[i].unmute=false;
                                    this.meetingroomList[i].reinvite=false;
                                    return;
                                }
                            }
                                let iscustomerflag=0;
                                if( this.meetingroomList.length<=2&&memberNum!=this.agentNumber){
                                    iscustomerflag=1;
                                }
                                let member = {//取参加会议人的memberID
                                    "number":object.memberNumber,//改一下这边放被邀请人号码为membernumber
                                    "jointime":0,
                                    "statu":"已接通",
                                    "memberID":object.memberID,                    //然后还要放memberid进来 传到表格中的第五行(隐藏)
                                    "silence":true,
                                    "remove":removestatu,
                                    "unmute":false,
                                    "reinvite":false,
                                    "hour":0,
                                    "minute":0,
                                    "second":0,
                                    "iscustomerflag":iscustomerflag,
                                }
                                this.meetingroomList.push(member);



                    }
                }
                else if (eventMethod == "leave_conf") { //多方离开会议
                    if(object.memberNumber==eventAgent){
                        this.showMultiparty=false;
                    }
                    if (eventAgent == this.agentNumber) {
                            let member = object.memberNumber;//取离开会议人的工号
                            for(let i=0;i<this.meetingroomList.length;i++){//1遍历meetingroomList
                                if( member==this.meetingroomList[i].number){//在for循环判断,工号相等,修改其对应的值
                                    this.meetingroomList[i].statu="离开会议";
                                    this.meetingroomList[i].jointime=0;
                                    this.meetingroomList[i].hour=0;
                                    this.meetingroomList[i].minute=0;
                                    this.meetingroomList[i].second=0;
                                    this.meetingroomList[i].silence=false;
                                    this.meetingroomList[i].remove=false;
                                    this.meetingroomList[i].unmute=false;
                                    this.meetingroomList[i].reinvite=true;
                                    break;
                                }
                            }

                    }
                }
                //多方邀请参加返回
                else if (eventMethod == "conf_invite_result") {
                    if (eventAgent == this.agentNumber) {
                        if ("0" != retCode) {
                            let number = parseInt(object.reason);         //取邀请人的号码
                            for(let i=0;i<this.meetingroomList.length;i++){
                                if( number==this.meetingroomList[i].number){//在for循环判断,number相等,修改其对应的值,把此号码的状态改为邀请失败 时间为0
                                    if(retCode!="200"){
                                        this.meetingroomList[i].statu="未接通";
                                    }else{
                                        this.meetingroomList[i].statu="离开会议";
                                    }
                                    this.meetingroomList[i].jointime=0;
                                    this.meetingroomList[i].silence=false;
                                    this.meetingroomList[i].remove=false;
                                    this.meetingroomList[i].unmute=false;
                                    this.meetingroomList[i].reinvite=true;//失败了则按钮又变成重新邀请
                                    break;
                                }
                            }

                        }
                    }
                }
                //多方邀请被叫忙或拒接
                else if (eventMethod == "conf_invitee_hangup") {
                    if (eventAgent == this.agentNumber) {
                            let number = object.memberNumber;         //取邀请人的号码
                            for(let i=0;i<this.meetingroomList.length;i++){
                                if( number==this.meetingroomList[i].number){//在for循环判断,number相等,修改其对应的值,把此号码的状态改为邀请失败 时间为0
                                  if(retCode!="200"){
                                    this.meetingroomList[i].statu="未接通";
                                    }else{
                                      this.meetingroomList[i].statu="离开会议";
                                    }
                                    this.meetingroomList[i].jointime=0;
                                    this.meetingroomList[i].second = 0;
                                    this.meetingroomList[i].hour = 0;
                                    this.meetingroomList[i].minute = 0;
                                    this.meetingroomList[i].silence=false;
                                    this.meetingroomList[i].remove=false;
                                    this.meetingroomList[i].unmute=false;
                                    this.meetingroomList[i].reinvite=true;//失败了则按钮又变成重新邀请
                                    break;
                                }
                            }
                    }
                }

                else if (eventMethod == "get_queue_list") {
                    this.$emit("monitorData", frame.body);
                }else if (eventMethod == "hangup"  || eventMethod == "consultee_hangup") { //挂机、被询问座席挂断
                    if ("0" === retCode) { //挂断成功
                        // 播放嘟嘟声
                        if (localStorage.getItem("phoneType") != "0" && localStorage.getItem("phoneType") != "4") {
                            this.hangupAudio.loop = false;
                            this.hangupAudio.play();
                        }
                      window.clearTimeout(this.timOutTimer);
                      window.clearTimeout(this.timeForVideo);
                      if(that.haveVideo == '1'){
                        telephoneScreen.methods.clearAgentVideo();
                      }
                      this.internalFlag = '0';
                      this.callType="2";
                    }
                    if( eventMethod == "consultee_hangup"){
                        this.initBtnOpacity(true, true, false, false, false, true, false, false,false, true);
                    }

                }else if(eventMethod == "answer"){
                  let eventCallType = object.callType;
                  if("CTI_CALL_TYPE_COMMON_CALL_IN" == eventCallType){
                    this.customerPhoneFlag = true;
                  }
                }
            } else if (eventType == 'response') {

                if (eventMethod == "signin") {
                    this.opacity1 = false;
                    this.$Loading.finish();
                    if (retCode != "0") {
                        //签入失败，关闭连接
                        // this.disconnect();
                        this.$Message.info(this.getStatusMessage(retCode));

                        if(this.isSetExten){
                            this.extension='';
                            this.agentExten = '';
                            this.agentInfo.agentExten = '';
                            this.newAgentPassword='';
                            localStorage.setItem('agentInfo',JSON.stringify(this.agentInfo))
                            this.isSetExten=false;
                        }
                        // 将分机注销
                        this.unRegested();
                        return false;
                    }
                } else if (eventMethod == "signout") { //签入
                  if(reason == "3" && retCode == "0"){
                    that.$Modal.info({
                      title:'提示',
                      content:"当前座席号已在其他地方签入，请确认后继续操作"
                    });
                    this.opacity1 = false;
                    this.$Loading.finish();
                    this.second = 0;
                    this.hour = 0;
                    this.minute = 0;
                    this.outCount = 0;
                    this.disabled = true;

                    clearInterval(this.timeMount);

                    this.agentStatus = "-1";
                    this.unRegested();
                    this.showMultiparty=false;
                    localStorage.setItem("signinStatus", "0");
                    clearInterval(this.reconnectionCount);
                    this.reconnectionCount = "";

                    this.closeHeart = "0";
                    // this.disconnect();
                    if (eventMethod == "signout" && !that.forceSignOut) {

                      this.$Message.info("签出成功");
                      this.signalShow = false;
                      this.skillshow=false;
                      this.skillshow=false;
                      this.checkOutSign = "0";
                      that.pingicon = require('../../assets/image/signal0.png');
                      // 签出成功，清除ping
                      clearInterval(that.intervalFlag);
                      that.normalSignOut = false;
                      that.forceSignOut = false;
                      that.getTime();
                    }

                    this.checkInOrOutText = "签入";
                    this.setToolbarByStatus("-1");
                  }
                } else if (eventMethod == "manual_callout") { //呼出
                    if (retCode == '-19' || retCode == '-22') {
                        this.$Message.info("热线号码不正确，呼叫失败");
                    } else if (retCode == '-24' || retCode == '-31') {
                        this.$Message.info("座席非空闲状态，呼叫失败");
                    } else if (retCode != '0') {
                        this.$Message.info("呼叫失败，" + reason + "");
                    }
                } else if (eventMethod == "internal_call") { //内呼
                    if (retCode == '30') {
                        this.$Message.info("被叫座席不在线，呼叫失败");
                    } else if (retCode == '-24' || retCode == '-31') {
                        this.$Message.info("座席非空闲状态，呼叫失败");
                    } else if (retCode != '0') {
                        this.$Message.info("呼叫失败，" + reason + "");
                    }
                } else if (eventMethod == "blind_transfer") { //转接座席
                    if (retCode == '30') {
                        this.$Message.info("被叫座席不在线，呼叫失败");
                    } else if (retCode == '-24' || retCode == '-31') {
                        this.$Message.info("座席非空闲状态，呼叫失败");
                    } else if (retCode != '0') {
                        this.$Message.info("呼叫失败，" + reason + "");
                    }
                } else if (eventMethod == "transfer_queue") { //转接技能组
                    if (retCode != '0') {
                        this.$Message.info("呼叫失败，" + reason + "");
                    }
                } else if (eventMethod == "transfer_ivr") { //转接IVR
                    if (retCode != '0') {
                        this.$Message.info("呼叫失败，" + reason + "");
                    }
                } else if (eventMethod == "blind_outbound") { //转接外线
                    if (retCode != '0') {
                        this.$Message.info("呼叫失败，" + reason + "");
                    }
                } else if (eventMethod == "consult") { //询问座席
                    if (retCode == '30') {
                        this.$Message.info("被叫座席不在线，呼叫失败");
                        //this.initBtnOpacity(true, true, false, false, false, true, false, false, false, true);

                       this.initBtnOpacity(true, true, false, false, false, true, false, false,false, true);
                    } else if (retCode == '-24' || retCode == '-31') {
                        this.$Message.info("座席非空闲状态，呼叫失败");
                        this.initBtnOpacity(true, true, false, false, false, true, false, false,false, true);
                    } else if (retCode != '0') {
                        this.$Message.info("呼叫失败，" + reason + "");
                        this.askPhoneFlag = false;
                       this.initBtnOpacity(true, true, false, false, false, true, false, false,false, true);
                    } else {

                        this.askPhoneFlag = true;
                    }
                } else if (eventMethod == "consult_outbound") { //询问外线
                    if (retCode != '0') {
                        this.$Message.info("呼叫失败，" + reason + "");
                        this.askPhoneFlag = false;
                       this.initBtnOpacity(true, true, false, false, false, true, false, false,false, true);
                    } else {

                        this.askPhoneFlag = true;
                    }
                } else if (eventMethod == "consult_cancel_result") { //取消询问
                    if (retCode != '0') {
                        this.$Message.info("取消询问失败，" + reason + "");
                    }
                } else if (eventMethod == "consultee_hangup") { //询问事件结束
                    this.initBtnOpacity(true, true, false, false, false, true, false, false,false, true);
                    this.askPhoneFlag = false;
                }else if (eventMethod == "conf_invite") { //多方邀请参加会议
                    if (retCode != '0') {
                        this.$Message.info("邀请参加会议失败，" + reason + "");
                    }
                }else if(eventMethod == "ai_assistant_msg"){
                  if(object.event.data){
                    let param={
                      data:object.event.data,
                      index:object.event.index,
                      direction:object.msgFlag,
                      agentNo:this.agentInfo.agentNumber,
                      name:this.agentInfo.employeeName,
                      time:this.getNowTime(),
                      customPhone:object.customerPhone
                    }
                    let that = this;
                    if( that.callType == '1' || that.callType == '2'){
                        window.initAiContent(param);
                     }
                  }
                }
                // else if (eventMethod == "threeway") { //三方
                //     if (retCode == '30') {
                //         this.$Message.info("被叫座席不在线，呼叫失败");
                //     } else if (retCode == '-24' || retCode == '-31') {
                //         this.$Message.info("座席非空闲状态，呼叫失败");
                //     } else if (retCode != '0') {
                //         this.$Message.info("呼叫失败，" + reason + "");
                //     }
                // }
                // else if (eventMethod == "threeway_outbound") { //三方外线
                //     if (retCode != '0') {
                //         this.$Message.info("呼叫失败，" + reason + "");
                //     }
                // } else if (eventMethod == "threeway_cancel") { //取消三方
                //     if (retCode != '0') {
                //         this.$Message.info("取消三方失败，" + reason + "");
                //     }
                // }
                else if (eventMethod == "heartbeat") { //心跳
                    if (retCode == '0') {
                        this.loseHeartbeat = 0;
                    }
                    // 心跳超时也属于异常，会发送disconnect命令，在disconnect命令中进行重连，这里不再进行重连
                    // } else {
                    //     // 10s重新连接一次

                    // this.clearAllReconnect();
                    // this.reconnectionCount.push(setInterval(function () {
                    //     that.reconnection();
                    // }, 10000));
                    // }
                }else if(eventMethod == "manual_callout_result"){
                  if("0" !== retCode){
                    this.$Message.error(reason);
                  }
                }
            }
        },
        initBtnOpacity: function (event3, event4, event5, event6, event7, event8, event9, event10, event11, event12, eventChat) {
            this.opacity3 = event3; //内呼
            this.opacity4 = event4; //呼出
            this.opacity5 = event5; //挂断
            this.opacity7 = event7; // 保持
            this.opacity8 = event8; //解除保持
            this.opacity9 = event9; // 转接
            this.opacity11 = event11; //多方
            this.opacity6 = event6; // 满意度
            this.opacity10 = event10; // 询问
            this.opacity12 = event12;
            this.opacityChat = eventChat ? eventChat : false; //在线客服
            if(this.agentInfo.isSupportChat == '2'){  //仅支持在线客服
                this.opacity3 = true; //内呼
                this.opacity4 = true; //呼出
            }
        },
        getStatusMessage: function (code) {
            let result = "签入失败";
            if (code == "-6") {
                result = "请不要重复签入";
            }
            if (code == "-11") {
                result = "分机不在线,签入失败";
            }
            if (code == "-12") {
                result = "分机已被其他座席绑定,签入失败";
            }
            if (code == "-53") {
                result = "密码错误,签入失败";
            }
            if (code == "-66") {
                result = "企业在线座席已达到最大,签入失败";
            }
            return result;
        },
        //退出登录
        outLogin: function (name) {
            if (name == '3') {
                if (this.subscribeId && this.checkInOrOutText == '签出') {
                    this.sendMessage("signout");
                    clearInterval(this.timeMount);
                }
                let that = this;
                let param = {
                    journalType: "用户退出登录",
                    menuId: "null",
                    valueDate:this.valueDate
                };
                this.$http.post("login/doLogOut.json", param).then(function (res) {
                    let result = res.data.flag;
                    if (result != "666") {
                        that.$Modal.info({
                            title: '提示',
                            content: res.data.msg
                        });
                        return false;
                    }
                });
                let loginUrl = localStorage.getItem("loginUrl");
                window.location.href = loginUrl;
            }
            if (name == '0') {
                this.$emit("openPeopleSet", 'people');
            }

            if(this.logTimer){
                clearInterval(this.logTimer);
            }
        },
        //信号状态变化明细
        checksignal: function () {
            this.$emit("openPeopleSet", 'signal');
        },
        sendMessage: function (methodValue, key, value) {
            let that = this;
            let content = "";
            if (key == "queueNumLstStr") {
                content = "'queueNumLstStr':'" + value + "',";
            } else if (key == "callee") {
                this.callPhone = value;
            }
            let exten = that.agentExten
            if('signin' == methodValue && '2' == that.agentInfo.isSupportChat){  //只支持在线客服
              exten = "";
            }
            let ip = that.useIp;
            if('signin' == methodValue || 'signout' == methodValue){  //只支持在线客服
              content += "'param1':'" + ip + "',";
            }
            let message = "{" + content + "'method':'" + methodValue + "','callee':'" + this.callPhone + "','agentno':'" + that.agentNumber + "','password':'" + that.agentPassword + "','exten':'" + exten + "','agentstatus':'0','pstnnumber':'" + localStorage.getItem("pstnNumber") + "','companyCode':'" + that.companyCode + "','timestamp':'"+ new Date()+ "' }";
            if (key == 'cusData') {
                message = "{" + content + "'method':'" + methodValue + "','callee':'" + this.callPhone + "','agentno':'" + that.agentNumber + "','password':'" + that.agentPassword + "','exten':'" + exten + "','agentstatus':'0','pstnnumber':'" + localStorage.getItem("pstnNumber") + "','companyCode':'" + that.companyCode + "','cusData':'" + value + "','timestamp':'"+ new Date()+ "' }";
            }
            if (methodValue.indexOf("companyCode") > 0) {
                message = methodValue;
            }

            if (that.mqClient && that.mqClient.connected) {
                that.mqClient.send("/queue/mpccReceiver", {
                  "content-type": "text/plain",
                  "x-message-ttl": "30000"
                }, message);
                return;
            }
            if(!that.valueDate){
              that.valueDate = new Date().getTime()+"_admin";
              localStorage.setItem("valueTime"+that.agentInfo.companyCode+"_"+that.agentInfo.agentNumber,that.valueDate);
              let param = {
                "valueDate":that.valueDate
              };
              that.$http.post('login/kickOutMq.json',param).then(res=>{
                let response = res.data
                that.spinShow = false
                if (response.flag !== '666') {
                  that.$Modal.info({
                    title:'提示',
                    content:response.msg
                  })
                  return false
                }
                that.checkIsAlive();
                that.connect();
              })

            }
            // else{
            //   let that = this;
            //   if('signin' == methodValue){
            //     setTimeout(function () {
            //       that.sendMessage("signin");
            //     },3000);
            //   }
            // }
        },
          //签入
        doSignIn: function(){
          this.phoneType = localStorage.getItem("phoneType");
          let param = {
            agentNumber: this.agentNumber,
            companyCode: this.companyCode,
            journalType: "null",
            menuId: "null",
            phoneType: this.phoneType,
            clientIp:this.useIp
          };
          let that = this;
          this.$http.post("employee/doAgentStatus.json", param).then(function (res) {
            let result = res.data.flag;
            that.checkOutSign = "1";
            that.isHandsOut = "0";
            if (result != "666") {
              that.$Modal.info({
                title: '提示',
                content: res.data.msg
              });
              that.opacity1 = false;
              that.$Loading.finish();
              return false;
            }
            if(!that.isConnectMq){
              console.info("当前mq未监听队列成功，暂停注册");
              if(that.valueDate){
                return false;
              }
            }
            let agentStatus = res.data.obj.agentStatus;
            if("-1" != agentStatus){
              that.forceSignOut = true;
            }

            if (that.phoneType != "0" && that.phoneType != '4') { //内置电话
              that.normalSignOut = true;
              if ("average" === res.data.obj.registeredStrategy) { //平均分配
                that.proxyList = res.data.obj.choiceProxy.split(",");
                if (that.proxyList.length > 0) {
                  that.fastIp.ip = that.proxyList[0].trim();
                  that.currentUrl = that.proxyList[0].trim();
                }
                that.pingStart();
                that.inRegister();
              } else { //最优分配
                that.proxyList = res.data.obj.proxyList.split(",");
                that.fastIp.ip = "";
                that.fastIp.delay = 0;
                that.pingStart();
                that.pingNum = 10; //大于4的数字
                if (that.proxyList.length > 1) {
                  that.currentUrl = that.proxyList[0].trim();
                  that.nextPingUrl = that.proxyList[1].trim();
                } else {
                  that.currentUrl = that.proxyList[0].trim();
                  that.nextPingUrl = "";
                }
                that.ping(that.currentUrl);

              }

            } else {
                that.sendMessage("signin");
            }
          });
        },

        selectAgentExtenList:function () {
          let that=this;
          let param={
            employeeCode:'',
            employeeName:'',
            agentExten:'',
            pstnNumber:'',
            agentNumber:'',
            employeeDepartment:'',
            agentState:'',
            employeeRole:'',
            pageNum:1,
            pageSize:20,
            journalType:"null",
            menuId:"null",
            supportVideo:'',
            aiAssistant:'',
            supportChat:'',
            employeeType:'',
          };
          this.queryParam = param;
          this.$http.post("employee/selectAllEmp.json",param) .then(function (res) {
            that.spinShow=false;
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            let obj=res.data.obj;
            that.ExtensionList=obj.agentExtenList;
          });
        },

        SetExtension:function(){
            if(this.extension == ''){
                this.$Modal.info({
                  title: '提示',
                  content: '请选择分机'
                });
                return;
            }
            let exten = this.ExtensionList.find(item=>item.agentExten == this.extension);
            // console.log(exten);
            this.agentExten = exten.agentExten;
            this.newAgentPassword = exten.agentPassword;
            this.agentInfo.agentExten = exten.agentExten;
            localStorage.setItem('agentInfo',JSON.stringify(this.agentInfo))
            this.showSetExtension=false;
            this.isSetExten=true;
            this.checkInOrOut();
        },
        //签入签出
        checkInOrOut: function () {
            this.opacity1 = true;
            this.$Loading.start();
            let that = this;
            if (this.checkInOrOutText == "签入") {
                if(this.agentExten == ''){
                    this.$Loading.finish();
                    this.opacity1 = false;
                    clearInterval(this.reconnectionCount);
                    this.reconnectionCount = "";
                    this.showSetExtension=true;
                    this.selectAgentExtenList();
                    return;
                }
                that.createdmeeting=false;
                let paramOne = {
                  agentExten: this.agentExten,
                  companyCode: this.companyCode,
                  token:that.token,
                  journalType: "null",
                  menuId: "null",
                }
              this.$http.post("login/doCheckExtenStatus.json", paramOne).then(function (res) {
                let result = res.data.flag;
                if (result != "666") {
                  that.$Modal.info({
                    title: '提示',
                    content: res.data.msg
                  });
                  that.opacity1 = false;
                  that.$Loading.finish();
                  if(that.isSetExten){
                    that.extension='';
                    that.agentExten = '';
                    that.agentInfo.agentExten = '';
                    that.newAgentPassword='';
                    localStorage.setItem('agentInfo',JSON.stringify(that.agentInfo))
                    that.isSetExten=false;
                  }
                  return false;
                }
                let agentStatus = res.data.obj.con;
                let agentNumber = res.data.obj.agentnum;
                if(res.data.obj.clientIp){
                  that.useIp = res.data.obj.clientIp;
                }
                if(agentStatus != '0' && that.loseHeartbeat < 3){
                    if(agentNumber != that.agentNumber){
                        that.$Modal.info({
                          title: '提示',
                          content: '当前分机号已被'+agentNumber+'签入'
                        });
                        that.agentExten='';
                        that.opacity1 = false;
                      that.$Loading.finish();
                      clearInterval(that.reconnectionCount);
                      that.reconnectionCount = "";
                      if(that.isSetExten){
                        that.extension='';
                        that.agentExten = '';
                        that.agentInfo.agentExten = '';
                        that.newAgentPassword='';
                        localStorage.setItem('agentInfo',JSON.stringify(that.agentInfo))
                        that.isSetExten=false;
                      }
                        return false;
                    }
                  that.$Modal.confirm({
                    title: '提示',
                    content:'当前座席号已被'+agentNumber+'签入，是否继续签入操作？',
                    onOk:()=>{
                      that.doSignIn();
                    },
                    onCancel:()=>{
                      that.opacity1 = false;
                      that.$Loading.finish();
                      clearInterval(that.reconnectionCount);
                      that.reconnectionCount = "";
                      return false;
                    }
                  })
                }else{
                  that.doSignIn();
                }
              }, function (res) {
                console.error("签入获取座席状态失败！");
                // 失败后，定时器会被关掉，这里重新打开
                if(that.reconnectionCount){
                  clearInterval(that.reconnectionCount);
                  that.reconnectionCount = "";
                }
                if(!that.reconnectionCount){
                  that.reconnectionCount = setInterval(function(){
                    that.reconnection();
                  },30000)
                }
              });
            } else {
                this.checkOutSign = "1";
                this.unRegested();
                this.isHandsOut = "1";
                this.sendMessage("signout");
                this.showMultiparty=false;
                if(this.isSetExten){
                    this.extension='';
                    this.agentExten = '';
                    this.agentInfo.agentExten = '';
                    this.newAgentPassword='';
                    localStorage.setItem('agentInfo',JSON.stringify(this.agentInfo))
                    this.isSetExten=false;
                }
            }
        },
        //
        inRegister: function(){
            let that = this;
            // 内置注册
                        setTimeout(function () {

                            that.WEBRTC_SERVICE = that.fastIp.ip;
                            if (that.WEBRTC_SERVICE == '' || that.WEBRTC_SERVICE == undefined) {
                                that.$Modal.info({
                                    title: '提示',
                                    content: '请联系管理员配置内置电话注册地址'
                                });
                                that.spinShow = false;
                                that.setToolbarByStatus('-1');

                                return false;
                            }
                            
                            that.sipRegister();
                            

                        }, 5000);
        },
        //webrtc分机注册
        sipRegister: function () {
            
            let that = this;
            
            
            // 先断开以前的连接
            if(that.userAgent && that.userAgent.isRegistered()){
                that.unRegested();
            }
            if (that.sipSocket != null) {
                that.sipSocket.disconnect();
            }
            
            console.log("do sipRegistering " + this.agentExten + ":address " + this.WEBRTC_SERVICE);
            this.incomingCallAudio.loop = true;
            this.remoteAudio.autoplay = true;

            // 进行号码登录注册
            var me_uri_joint = 'sip:' + this.agentExten + '@' + this.WEBRTC_SERVICE;
            var ws_uri = 'ws://' + this.WEBRTC_SERVICE + ':7070';
            var contact_uri = me_uri_joint + ';transport=ws';
            if (this.SCHEME.indexOf('https') > -1) {
                ws_uri = 'wss://' + this.WEBRTC_SERVICE + ':7071';
                contact_uri = me_uri_joint + ';transport=wss';
            }
            //   创建websocket
            that.sipSocket = new JsSIP.WebSocketInterface(ws_uri);
            that.sipSocket.retry = 0;
            //  配置参数
            var configuration = {
                sockets: [that.sipSocket],
                //outbound_proxy_set: ws_uri,
                uri: me_uri_joint,
                password: this.newAgentPassword==''?this.agentPassword:this.newAgentPassword,
                register: true, //指示JsSIP用户代理是否应在启动时自动注册
                contact_uri: contact_uri,
                ws_servers: ws_uri
                //session_timers: false  //启用会话定时器,默认值是true。
            };
            //  配置创建user agent
            that.userAgent = new JsSIP.UA(configuration);
            that.userAgent.retry = 0;
            //成功注册成功
            that.userAgent.on('registered', function (data) {

                if(that.normalSignOut || that.forceSignOut){  //正常签出才会进行再次注册
                    // 注册成功，取消端口连接监听
                    console.info("registered: ", data.response.status_code, ",", data.response.reason_phrase);
                    setTimeout(function () {
                        that.sendMessage("signin");
                    }, 2000);
                }
            });
            //由于注册失败而被解雇
            that.userAgent.on('registrationFailed', function (data) {
                if (!that.userAgent.isRegistered() && that.normalSignOut) { //该帐号没注册且不是正常签出
                    console.log("registrationFailed, ", data);

                    that.againRegister();
                }
            });
            //
            that.userAgent.on('disconnected', function (data) {
                if(that.userAgent){
                    if (!that.userAgent.isRegistered() && that.normalSignOut) {
                        console.log("Disconnected, ", data);
                        that.againRegister();
                    }
                }
            });

            // 在注册期间发射几秒钟，如果应用程序没有为这个事件设置任何监听器，JsSIP将像往常一样重新注册。
            that.userAgent.on('registrationExpiring', function () {
                //过期之后将自动重新注册,每隔1分钟会执行一次，如果不执行，会触发10分钟分机下线机制
                console.warn("registrationExpiring");
                //重新注册
                if(that.userAgent != null){
                    
                    that.userAgent.register();
                    
                }
            });
            // 注销下线事件
            that.userAgent.on('unregistered', function () {
                console.warn("unregistered");
            });

            //为传入或传出的会话/呼叫。
            that.userAgent.on('newRTCSession', function (data) {
                console.info('onNewRTCSession: ', data);
                if (data.originator == 'remote') { //来电呼入

                    that.incomingSession = data.session;
                    that.timOutTimer = setTimeout(function () {
                        let phoneType = localStorage.getItem("phoneType");//话机类型 0-外置电话 1-内置 2-内置呼出自动接听 3-内置全部自动接听 4-外置话机自动接听
                        console.info("incoming call,phoneType=" + phoneType + ",calloutFlag=" + that.calloutFlag);
                        if (phoneType == "3") {
                            that.answerOrCancel(true);
                        } else if (phoneType == "2" && that.calloutFlag == '1') {
                            that.answerOrCancel(true);
                        } else {
                            that.incomingCallAudio.play();
                            that.showIncoming = true;
                        }
                        that.calloutFlag == '0';
                    }, 2000);

                    //data.session.answer({ 'mediaConstraints': this.constraints, 'mediaStream': null });
                } else { //去电呼出
                    console.info("outgoingSession");
                    outgoingSession = data.session;
                    outgoingSession.on('connecting', function (data) {
                        //通话状态
                        Callstate.innerText = "连接中";
                        globalCallPhoneStates = "连接中";
                        console.info('onConnecting - ', data.request);
                        currentSession = outgoingSession;
                        outgoingSession = null;
                    });
                }
                //远程挂断事件
                data.session.on("ended", function(data) {
                  console.log("call end", data);
                  if(that.haveVideo == '1'){
                    telephoneScreen.methods.clearAgentVideo();
                  }
                });
                data.session.on('accepted', function (data) {
                    console.info('onAccepted - ', data);
                    if (data.originator == 'remote' && that.currentSession == null) {
                        that.currentSession = that.incomingSession;
                        that.incomingSession = null;
                        console.info("setCurrentSession - ", currentSession);
                    }
                });

                data.session.on('confirmed', function (data) {
                    console.info('onConfirmed - ', data);
                    if (data.originator == 'remote' && this.currentSession == null) {
                        that.currentSession = that.incomingSession;
                        that.incomingSession = null;
                        console.info("setCurrentSession - ", this.currentSession);
                    }
                });

                data.session.on('sdp', function (data) {
                    console.info('onSDP, type - ', data.type, ' sdp - ', data.sdp);
                });

                data.session.on('progress', function (data) {
                    console.info('onProgress - ', data.originator);
                    if (data.originator == 'remote') {
                        console.info('onProgress, response - ', data.response);
                    }
                });

                data.session.on('peerconnection', function (data) {
                    console.info('onPeerconnection - ', data.peerconnection);
                    data.peerconnection.onaddstream = function (ev) {
                        console.info('onaddstream from remote - ', ev);
                        that.remoteAudio.srcObject = ev.stream;
                        console.info(that.haveVideo+"callType："+that.callType+"isScreen："+that.isScreen);
                        if(that.haveVideo == '1' && that.callType != '0' && that.isScreen){
                          telephoneScreen.methods.doAgentVideo(ev.stream);
                          console.info("isOK");
                        }
                    };
                });

                data.session.on('addstream', function (e) {
                    console.info('on addstream - ');
                    that.incomingCallAudio.pause();
                    that.remoteAudio.src = e.stream;
                });

                data.session.on('failed', function (e) {
                    console.info('on failed - ');
                    if (that.incomingSession != null) {
                        that.incomingSession = null;
                    }
                    that.incomingCallAudio.pause();
                    that.showIncoming = false;
                });

                if (data.session.direction === 'incoming') {}

            });

            /**
             * 连接到信令服务器，如果是之前停止则恢复到停止之前的状态，如果是刷新操作‘’
             * 而且configuration的register参数设置为true则直接注册到信令服务器
             */
            that.userAgent.start();
        },
        // sip注册失败后，包括连接超时，会向下一个proxy地址重新注册
        againRegister: function () {
            for (let i = 0; i < this.proxyList.length; i++) {
                if (this.WEBRTC_SERVICE !== this.proxyList[i].trim()) {
                    this.WEBRTC_SERVICE = this.proxyList[i].trim();
                    this.fastIp.ip = this.proxyList[i].trim();
                    this.currentUrl = this.proxyList[i].trim();
                    if (this.userAgent == null || !this.userAgent.isRegistered()) {
                        this.sipRegister();
                    }
                }
            }
        },
        //分机注销
        unRegested: function () {
            var options = {
                all: true
            };
            if (this.userAgent != null) {
                console.log("do unregister");
                this.userAgent.unregister(options);
            }
            //userAgent.stop();//保存当前的注册状态并在正常注销并终止活动会话（如果有）后断开与信令服务器的连接。
        },
        callOut: function (sign) {
            //内呼,呼出
            if (sign == '0' || sign == '1') {
                this.duofanging=false;
                this.createdmeeting=false;
                if (this.agentStatus != '0' && this.agentStatus != '8') {
                    this.$Message.info("座席不在空闲状态!清先切换座席状态");
                    return false;
                }
                this.callType = sign;
                if (sign == '0') {
                    this.showInternalCall = true;
                }
                if (sign == '1') {
                    this.showDialer = true;
                }
                return false;
            }
            //挂断
            if (sign == '2') {
                this.method = "hangup";
                this.showMultiparty=false;
                this.showInvitepage=false;
                this.duofanging=false;
            }
            //满意度
            if (sign == '3') {
                if(this.duofanging==true){
                    this.method = "conf_evaluate";
                }else{
                    this.method = "evaluate";
                }
                this.showMultiparty=false;
                this.showInvitepage=false;
            }
            //保持
            if (sign == '4') {
                this.method = "hold";
            }
            //解除保持
            if (sign == '5') {
                this.method = "unhold";
            }
            //询问
            if (sign == '7') {
                this.method = "hangup";
            }
            //三方
            // if (sign == '8') {
            //     this.method = "threeway";
            // }
            //多方
            if (sign == '8') {
                if(this.createdmeeting==false){
                    this.method = " conf_create";
                }
            }

            //在线客服
            // if (sign == '9') {
            //    this.method = "hangup";
            // }
            this.sendMessage(this.method);
        },
        // 打开在线客服
        getinto:function(){//在线客服
                this.$emit("openPeopleSet", 'online');
        },
        //外呼点击拨号
        closeDialerPage: function (flag, callPhone, sign, cusData) {
            if (!flag) {
                this.showDialer = false;
            }
            let param = {
                journalType: "null",
                menuId: "null"
            };
            let that = this;
            that.$http.post("config/beforeCall.json", param).then(function (res) {
                let result = res.data.flag;
                if (result != "666") {
                    that.$Modal.info({
                        title: '提示',
                        content: res.data.msg
                    });
                    return false;
                }
                if (sign) {
                    that.callType = sign;
                }
                if (flag) {
                    if (that.agentStatus != '0' && that.agentStatus != '8') {
                        that.$Message.info("座席不在空闲状态，不允许拨打");
                        return false;
                    }

                    if (that.callPhone != callPhone) {
                        that.callPhone = callPhone;
                    }
                    if (that.callType == '1') { //呼出
                        if (cusData) {
                            that.sendMessage("manual_callout", 'cusData', cusData);
                        } else {
                            that.sendMessage("manual_callout");
                        }
                    }
                    if (that.callType == '2') {
                        that.callType='1';
                        if (cusData) {
                            that.sendMessage("manual_callout", 'cusData', cusData);
                        } else {
                            that.sendMessage("manual_callout");
                        }
                    }
                }
            });
        },
        closedtmf:function(value){//dtmf按键
            let that = this;
            if (that.agentStatus == '2' || that.agentStatus == '10') {
                that.currentSession.sendDTMF(value);
            }
        },
        //内呼选座席
        closeInternal:function (flag, callPhone, sign, cusData) {
            let param = {
                journalType: "null",
                menuId: "null"
            };
            let that = this;
            that.$http.post("config/beforeCall.json", param).then(function (res) {
                let result = res.data.flag;
                if (result != "666") {
                    that.$Modal.info({
                        title: '提示',
                        content: res.data.msg
                    });
                    return false;
                }
                if (sign) {
                    that.callType = sign;
                }

                if (that.callType == '0') { //内呼
                    that.showInternalCall = false;
                }
                if (flag) {
                    if (that.agentStatus != '0' && that.agentStatus != '8') {
                        that.$Message.info("座席不在空闲状态，不允许拨打");
                        return false;
                    }

                    if (that.callPhone != callPhone) {
                        that.callPhone = callPhone;
                    }
                    if (that.callType == '0') { //内呼
                        that.sendMessage("internal_call");
                        that.calloutFlag = '1';
                    }
                }
            });
        },
        //点击转接/询问/三方弹出页面
        transfer: function (name) {
            if (name == "askTransfer") { //确定询问
                let message = "{'companyCode':'" + this.companyCode + "','method':'consult_transfer','agentno':'" + this.agentNumber + "','pstnnumber':'" + localStorage.getItem("pstnNumber")  + "','timestamp':'"+ new Date()+ "' }";
                this.sendMessage(message);
                return false;
            } else if (name == "cancelAsk") { //取消询问
                let message = "{'companyCode':'" + this.companyCode + "','method':'consult_cancel','agentno':'" + this.agentNumber + "','pstnnumber':'" + localStorage.getItem("pstnNumber")  + "','timestamp':'"+ new Date()+ "' }";
                this.sendMessage(message);
                return false;
            }
            // else if (name == "cancelThreeway") { //取消三方
            //     let message = "{'companyCode':'" + this.companyCode + "','method':'threeway_cancel','agentno':'" + this.agentNumber + "','pstnnumber':'" + localStorage.getItem("pstnNumber") + "'}";
            //     this.sendMessage(message);
            //     return false;
            // }
            this.transferType = name;
            this.showTransfer = true;
        },
        //开始转接/询问/三方
        closeTransferPage: function (type, callPhone) {
            if (type == "cancel") {
                this.showTransfer = false;
                return false;
            }
            if (this.agentStatus != '2' && this.agentStatus != '10') {
                this.$Message.info("座席不是通话状态，不允许操作");
                return false;
            }
            if (type == 'agent') { //转接座席
                let message = "{'companyCode':'" + this.companyCode + "','method':'blind_transfer','agentno':'" + this.agentNumber + "','callee':'" + callPhone + "','pstnnumber':'" + localStorage.getItem("pstnNumber") + "','timestamp':'"+ new Date()+ "' }";
                this.sendMessage(message);
            } else if (type == 'queue') { //转接技能组
                let message = "{'companyCode':'" + this.companyCode + "','method':'transfer_queue','agentno':'" + this.agentNumber + "','queueNum':'" + callPhone + "','pstnnumber':'" + localStorage.getItem("pstnNumber") + "','timestamp':'"+ new Date()+ "' }";
                this.sendMessage(message);
            } else if (type == 'ivr') { //转接IVR
                let message = "{'companyCode':'" + this.companyCode + "','method':'transfer_ivr','agentno':'" + this.agentNumber + "','ivrNum':'" + callPhone + "','pstnnumber':'" + localStorage.getItem("pstnNumber") + "','timestamp':'"+ new Date()+ "' }";
                this.sendMessage(message);
            } else if (type == 'pstn') { //转接外线
                let message = "{'companyCode':'" + this.companyCode + "','method':'blind_outbound','agentno':'" + this.agentNumber + "','callee':'" + callPhone + "','pstnnumber':'" + localStorage.getItem("pstnNumber") + "','timestamp':'"+ new Date()+ "' }";
                this.sendMessage(message);
            } else if (type == 'askAgent') { //询问座席
                let message = "{'companyCode':'" + this.companyCode + "','method':'consult','agentno':'" + this.agentNumber + "','callee':'" + callPhone + "','pstnnumber':'" + localStorage.getItem("pstnNumber") + "','timestamp':'"+ new Date()+ "' }";
                this.sendMessage(message);
                //this.initBtnOpacity(true, true, false, false, false, true, false, false,false, true);
                this.initBtnOpacity(true, true, false, false, false, true, false, false, true, true);

            } else if (type == 'askPstn') { //询问外线
                let message = "{'companyCode':'" + this.companyCode + "','method':'consult_outbound','agentno':'" + this.agentNumber + "','callee':'" + callPhone + "','pstnnumber':'" + localStorage.getItem("pstnNumber") + "','timestamp':'"+ new Date()+ "' }";
                this.sendMessage(message);
                this.initBtnOpacity(true, true, false, false, false, true, false, false, true, true);
            }
            // else if (type == 'threeway') { //三方座席
            //     let message = "{'companyCode':'" + this.companyCode + "','method':'threeway','agentno':'" + this.agentNumber + "','callee':'" + callPhone + "','pstnnumber':'" + localStorage.getItem("pstnNumber") + "'}";
            //     this.sendMessage(message);
            // } else if (type == 'threewayPstn') { //三方外线
            //     let message = "{'companyCode':'" + this.companyCode + "','method':'threeway_outbound','agentno':'" + this.agentNumber + "','callee':'" + callPhone + "','pstnnumber':'" + localStorage.getItem("pstnNumber") + "'}";
            //     this.sendMessage(message);
            // }
            this.showTransfer = false;
        },
        //点击接听
        answerOrCancel: function (flag) {//flag代表座席信息获取的状态,-1此座席离线,0此座席在线,-99此座席在数据库中找不到或者暂时被禁用
            let that = this;
            this.showIncoming = false;
            if(localStorage.getItem("phoneType") == "0" || localStorage.getItem("phoneType") == "4"){
              if(flag){
                that.createdmeeting=false;
                let message = "{'method':'pickup','agentno':'" + this.agentNumber + "','companyCode':'" + this.companyCode + "','timestamp':'"+ new Date()+ "' }";
                this.sendMessage(message);
              }else{
                let message = "{'method':'hangup','agentno':'" + this.agentNumber + "','companyCode':'" + this.companyCode + "','timestamp':'"+ new Date()+ "' }";
                this.sendMessage(message);
              }
              return false;
            }
            if (flag) {
                that.createdmeeting=false;
                that.incomingCallAudio.pause();
                if(that.haveVideo == '1' && that.callType == '1'){
                    telephoneScreen.methods.initAgentVideo();
                }
                that.incomingSession.answer({
                  'mediaConstraints': that.constraints,
                  'mediaStream': null
                });

            } else {
                let options = {
                    all: false
                };
                if (that.incomingSession != null) {
                    that.incomingCallAudio.pause();
                    that.incomingSession.terminate(options);
                } else {
                    that.userAgent.terminateSessions(options); //终止当前对话
                }
              if(that.haveVideo == '1'){
                telephoneScreen.methods.clearAgentVideo();
              }
            }
        },
        //tabs标签页点击事件
        browseNotice: function (name) {
            this.search = "";
            if ("second" == name) {
                this.searchCollect();
                this.tabsName = "2";
            }
            if ("third" == name) {
                this.initSearch("3");
                this.tabsName = "3";
            }
            if ("first" == name) {
                this.initSearch("1");
                this.tabsName = "1";
            }
        },
        //关闭知识库内容查看
        closeknowContentPop: function () {
            this.openDataKnlgPop = false;
            if ("1" == this.tabsName) {
                this.initSearch("1");
            }
            if ("2" == this.tabsName) {
                this.searchCollect();
            }
        },
        //打开个人知识添加
        addPersonKnow: function () {
            this.openPersonKnowPop = true;
            this.personId = "";
        },
        //打开个人知识编辑
        editPersonKnow: function (id) {
            this.openPersonKnowPop = true;
            this.personId = id + "";
        },
        //收藏取消添加方法
        changeLove: function (id, collectState) {
            let that = this;
            let journalType = "知识库内容收藏";
            if ("0" == collectState) {
                collectState = "1";

            } else {
                collectState = "0";
                journalType = "知识库内容取消收藏";
            }
            let param = {
                id: id + "",
                type: collectState,
                journalType: journalType,
                menuId: "null"
            };
            this.$http.post("knowledge/doCollectors.json", param).then(function (res) {
                let result = res.data.flag;
                if (result != "666") {
                    that.$Modal.info({
                        title: '提示',
                        content: res.data.msg
                    });
                    return false;
                }
                if ("1" == that.tabsName) {
                    that.initSearch("1");
                }
                if ("2" == that.tabsName) {
                    that.searchCollect();
                }
            });
        },
        //关闭个人知识添加页面
        closePersonKnowPop: function (flag) {
            this.openPersonKnowPop = false;
            if (flag) {
                this.initSearch("3");
            }
        },
        //打开查看知识库内容
        openKnlgContent: function (id,name) {
            name = name.replace(/<[^>]+>/g,"");
            if(name && name.length>5){
              name = name.substring(0,5)+"…";
            }
            this.$emit("openPeopleSet", 'know', id+"-"+name);
            // this.contentId=id+"";
            // this.openDataKnlgPop=true;
        },
        //加载收藏数据
        initSearch: function (name) {
            let TreeIdForSelect = this.selectedTreeId;
            if ("0" == this.selectedTreeId) {
                TreeIdForSelect = "";
            }
            let remark = '';
            if ("1" == name) {
                //为1时是搜索全部知识
                remark = '1';
            } else if ("3" == name) {
                //为3为个人知识
                remark = '0';
                TreeIdForSelect = "";
            }
            let param = {
                type: '1',
                search: this.search,
                remark: remark,
                baseId: TreeIdForSelect,
                journalType: "null",
                menuId: "null",
            };
            let that = this;
            this.$http.post("knowledge/toIndex.json", param).then(function (res) {
                let result = res.data.flag;
                if (result != "666") {
                    that.$Modal.info({
                        title: '提示',
                        content: res.data.msg
                    });
                    return false;
                }
                let list = res.data.obj.list.content;
                if (!that.search) {
                    that.infoTableList = list;
                    return false;
                }
                for (let i = 0; i < list.length; i++) {
                  let tittle = list[i].tittle;
                  let count = 0;
                  if (tittle) {
                    let ziMuReg = new RegExp(/[A-Za-z]/);
                    let index = tittle.indexOf(that.search);
                    if (ziMuReg.test(that.search)) {
                      let placeVal = that.search.replace(/(^\s*)|(\s*$)/g, "");
                      let zimuPlace = new RegExp(placeVal, "gi");
                    }
                    while (index != -1) {
                      count++;
                      tittle = tittle.substring(0, index) + "\<span style='background-color: #2894FF;color: #ffff;'\>" + that.search + "\</span\>" + tittle.substring(index + that.search.length, tittle.length);
                      index = tittle.indexOf(that.search, index + 61 + that.search.length);
                    }
                  }
                  list[i].tittle = tittle;
                }
                for (let i = 0; i < list.length; i++) {
                    let content = list[i].content;
                    let count = 0;
                    if (content) {
                        let ziMuReg = new RegExp(/[A-Za-z]/);
                        let indexContent = content.indexOf(that.search);
                        if (ziMuReg.test(that.search)) {
                            let placeVal = that.search.replace(/(^\s*)|(\s*$)/g, "");
                            let zimuPlace = new RegExp(placeVal, "gi");
                        }
                        let indexOne = 0;
                        let indexTwo = 0;
                        while (indexContent != -1) {
                          count++;
                          indexOne = content.indexOf(">",indexOne+1);
                          indexTwo = content.indexOf("<",indexOne);
                          if((indexContent > indexOne && indexContent < indexTwo) || indexOne == -1 || indexTwo == -1){
                            content = content.substring(0, indexContent) + "\<span style='background-color: #2894FF;color: #ffff;'\>" + that.search + "\</span\>" + content.substring(indexContent + that.search.length, content.length);
                            indexContent = content.indexOf(that.search, indexContent + 61 + that.search.length);
                          }else{
                            indexContent = content.indexOf(that.search, indexTwo);
                          }
                        }
                    }
                    list[i].content = content;
                }
                that.infoTableList = list;
            });
        },
        //个人知识删除
        deletePersonKnow: function (id) {
            let param = {
                type: '1',
                remark: '0',
                id: id + "",
                journalType: "知识检索=>个人知识管理=>删除",
                menuId: "null"
            };
            let that = this;
            this.$Modal.confirm({
                title: '提示',
                content: "是否确定删除",
                onOk: () => {
                    that.$http.post("knowledge/doDelete.json", param).then(function (res) {
                        let result = res.data.flag;
                        if (result != "666") {
                            that.$alert(res.data.msg, '提示', {
                                confirmButtonText: '确定'
                            });
                            return false;
                        }
                        that.initSearch("3");
                    });
                }
            });
        },
        //个人收藏查询
        searchCollect: function () {
            let TreeIdForSelect = this.selectedTreeId;
            if ("0" == this.selectedTreeId) {
                TreeIdForSelect = "";
            }
            let param = {
                search: this.search,
                baseId: TreeIdForSelect,
                journalType: "null",
                menuId: "null",
            };
            let that = this;
            this.$http.post("knowledge/toCollectsIndex.json", param).then(function (res) {
                let result = res.data.flag;
                if (result != "666") {
                    that.$Modal.info({
                        title: '提示',
                        content: res.data.msg
                    });
                    return false;
                }
                let list = res.data.obj.list;
                if (!that.search) {
                    that.infoTableList = list;
                    return false;
                }
              for (let i = 0; i < list.length; i++) {
                let tittle = list[i].tittle;
                let count = 0;
                if (tittle) {
                  let ziMuReg = new RegExp(/[A-Za-z]/);
                  let index = tittle.indexOf(that.search);
                  if (ziMuReg.test(that.search)) {
                    let placeVal = that.search.replace(/(^\s*)|(\s*$)/g, "");
                    let zimuPlace = new RegExp(placeVal, "gi");
                  }
                  while (index != -1) {
                    count++;
                    tittle = tittle.substring(0, index) + "\<span style='background-color: #2894FF;color: #ffff;'\>" + that.search + "\</span\>" + tittle.substring(index + that.search.length, tittle.length);
                    index = tittle.indexOf(that.search, index + 61 + that.search.length);
                  }
                }
                list[i].tittle = tittle;
              }
              for (let i = 0; i < list.length; i++) {
                let content = list[i].content;
                let count = 0;
                if (content) {
                  let ziMuReg = new RegExp(/[A-Za-z]/);
                  let indexContent = content.indexOf(that.search);
                  if (ziMuReg.test(that.search)) {
                    let placeVal = that.search.replace(/(^\s*)|(\s*$)/g, "");
                    let zimuPlace = new RegExp(placeVal, "gi");
                  }
                  let indexOne = 0;
                  let indexTwo = 0;
                  while (indexContent != -1) {
                    count++;
                    indexOne = content.indexOf(">",indexOne+1);
                    indexTwo = content.indexOf("<",indexOne);
                    if((indexContent > indexOne && indexContent < indexTwo) || indexOne == -1 || indexTwo == -1){
                      content = content.substring(0, indexContent) + "\<span style='background-color: #2894FF;color: #ffff;'\>" + that.search + "\</span\>" + content.substring(indexContent + that.search.length, content.length);
                      indexContent = content.indexOf(that.search, indexContent + 61 + that.search.length);
                    }else{
                      indexContent = content.indexOf(that.search, indexTwo);
                    }
                  }
                }
                list[i].content = content;
              }
              that.infoTableList = list;
            });
        },
        //搜索知识
        searchContent: function () {
            if ("1" == this.tabsName || "2" == this.tabsName) {
                if (this.search) {
                    //let reg = /^[0-9\u4E00-\u9FA5]*$/;
                    let reg =/^[A-Za-z0-9\u4e00-\u9fa5]+$/gi;
                    if (!reg.test(this.search)) {
                        this.$Message.info("只能输入数字,汉字,字母");
                        return false;
                    }
                }
            }
            if ("1" == this.tabsName) {
                this.initSearch("1");
            }
            if ("2" == this.tabsName) {
                this.searchCollect();
            }
            if ("3" == this.tabsName) {
                this.initSearch("3");
            }
        },
        showKnowTree: function (event) {
            if (event) {
                this.initKnowledgeTree("knowledgeTree");
            }
        },
        clickDrawer: function () {
            if (this.drawer) {
                this.drawer = false;
                return false;
            }
            this.drawer = true;
            this.initKnowledgeTree("knowledgeTree");
            if ("1" == this.tabsName) {
                this.initSearch("1");
            }
            if ("2" == this.tabsName) {
                this.searchCollect();
            }
            if ("3" == this.tabsName) {
                this.initSearch("3");
            }
        },
        beforeunloadFn: function (e) {
            if('a' == e.srcElement.activeElement.localName){
              return false;
            }
            if(this.mqClient && this.mqClient.connected){
              if(this.checkInOrOutText == "签出"){
                this.unRegested();
                let message = "{'param1':'"+this.useIp+"','method':'signout','callee':'" + this.callPhone + "','agentno':'" + this.agentNumber + "','password':'" + this.agentPassword + "','exten':'" + this.agentExten + "','agentstatus':'0','pstnnumber':'" + localStorage.getItem("pstnNumber") + "','companyCode':'" + this.companyCode + "','timestamp':'"+ new Date()+ "' }";
                this.mqClient.send("/queue/mpccReceiver", {
                  "content-type": "text/plain",
                  "x-message-ttl": "30000"
                }, message);
              }
              this.disconnect();
            }
            // 退出接口
            let param = {
              journalType: "刷新页面退出登录",
              menuId: "null",
              valueDate:this.valueDate,
              localName:e.srcElement.activeElement.localName
            };
            this.$http.post("login/doLogOut.json", param).then(function (res) {});
        },
        // 重连方法
        reconnection: function (index) {
            if(!this.reconnectionCount && !index){
              return;
            }
            let that = this;
            clearInterval(that.intervalFlag);
            that.checkInOrOutText = "签入";
            that.normalSignOut = true;
            console.log("网络错误，座席重连中...");
            this.$Message.info("网络错误，座席重连中...");
            // that.userAgent = null;
            that.unRegested();
            this.setToolbarByStatus("-1");
            that.checkInOrOut();
        },
        //mq的重连
        reconnectMq: function () {
          this.isConnectMq = false;
          let autoSignIn = localStorage.getItem("autoSignIn");
          //判断是否已经点击过签入，或者自动签入未手动签出的
          if("1" == this.checkOutSign || ('1' == autoSignIn && "0" == this.isHandsOut)){
            this.checkInOrOutText = "签入";
            this.normalSignOut = true;
            // this.userAgent = null;
            this.setToolbarByStatus("-1");
            console.log("网络错误，座席重连中...");
            this.unRegested();
            window.clearInterval(this.reconnectionCount);
            this.reconnectionCount = "";
            this.loseHeartbeat = 3;
          }
          this.disconnect();
          let param={
            valueDate:this.valueDate,
          };
          let that = this;
          this.$http.post("login/keepLoginAlive.json",param).then(function (res) {
            let result = res.data.flag;
            if(result != "666"){
              if (that.subscribeId) {
                clearInterval(that.timeMount);
              }
              that.unRegested();
              that.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  that.outLogin("3");
                }
              });
              return false;
            }
            console.log("与mq断开连接，正在重连中...");
            that.connect();
          }, function (res) {
            that.$Loading.start();
            console.error("验活失败！重新验证");
            // 失败后，定时器会被关掉，这里重新打开
            setTimeout(function(){
              that.reconnectMq();
            },10000)
          });
        },
        //mq重连成功之后的动作，是否发signin
        isAutoSignIn:function() {
          this.isConnectMq = true;
          console.log("mq连接成功...");
          let autoSignIn = localStorage.getItem("autoSignIn");
          //这里重新挂载交换机
          let paramOne = {
            agentNumber: this.agentNumber,
            companyCode: this.companyCode,
            journalType: "null",
            menuId: "null",
          }
          let that = this;
          this.$http.post("login/doQueueBinding.json", paramOne).then(function (res) {
            let result = res.data.flag;
            if (result != "666") {
              that.$Modal.info({
                title: '提示',
                content: res.data.msg
              });
              return false;
            }
          });
          if("1" == this.checkOutSign || ('1' == autoSignIn && "0" == this.isHandsOut)){
            let paramOne = {
              agentNumber: this.agentNumber,
              companyCode: this.companyCode,
              token: this.token,
              journalType: "null",
              menuId: "null",
            }
            let that = this;
            this.$http.post("login/doCheckAgentStatus.json", paramOne).then(function (res) {
              let result = res.data.flag;
              if (result != "666") {
                that.$Modal.info({
                  title: '提示',
                  content: res.data.msg
                });
                return false;
              }
              let agentStatus = res.data.obj.agentStatus;
              if ("-1" != agentStatus) {
                let message = "{'param1':'"+that.useIp+"','method':'signout','callee':'" + that.callPhone + "','agentno':'" + that.agentNumber + "','password':'" + that.agentPassword + "','exten':'" + that.agentExten + "','agentstatus':'0','pstnnumber':'" + localStorage.getItem("pstnNumber") + "','companyCode':'" + that.companyCode + "','timestamp':'"+ new Date()+ "' }";
                that.mqClient.send("/queue/mpccReceiver", {
                  "content-type": "text/plain",
                  "x-message-ttl": "30000"
                }, message);
                that.$Message.info("网络异常，正在重新签入....");
              }
              console.log("已经签入过，开始重新签入...");
              if (that.valueDate && that.valueDate.indexOf("_admin") != -1) {
                //admin切过来的座席由于已经sip注册过，所以mq连接成功后直接发送signin即可
                that.sendMessage("signin");
                //半分钟再次判断状态，签入成功则取消签入
                that.connectTimeOut = setInterval(function () {
                  if (!that.signalShow) {
                    that.sendMessage("signin");
                  }
                }, 30000);
                return;
              }
              that.checkInOrOut();
              that.isHandsOut = "0";
            });
          }
        },
        //ping方法
        ping: function (url) {
            let that = this;
            that.pingNum++;
            that.startTime = new Date().getTime();
            that.objIMG.src = that.SCHEME+"//" + url + "/favicon.ico?time=" + that.startTime;
        },
        //签入成功后的ping
        pingStart: function () {
            let that = this;
            that.objIMG = new Image();
            that.objIMG.retry = 0;
            that.objIMG.onload = () => {

                that.endTime = new Date().getTime();
                let delay = that.endTime - that.startTime;

                if (that.pingNum <= 4) {
                    if (delay > 0) {
                        that.pingDelays.push(delay);
                    }
                    that.ping(that.fastIp.ip);
                    // that.timeoutFlag.push(setTimeout(that.timeout), 2000); //2s不响应，即为超时
                }else if(that.pingNum >= 10){ //大于10，表示是点击签入时的ping事件

                    if (that.fastIp.delay == 0 || delay < that.fastIp.delay) {
                        that.fastIp.delay = delay;
                        that.fastIp.ip = that.currentUrl;
                    }
                    if (that.nextPingUrl != undefined && that.nextPingUrl != '') {
                        if(that.proxyList.length == (that.pingNum - 10)){  // 如果所有的proxy已经ping完，启动注册
                            that.pingNum = 0;
                            that.inRegister();
                        }else{
                            // 寻找当前ping在proxyList中的位置
                            for (let n = that.proxyList.indexOf(that.currentUrl) + 1; n < that.proxyList.length; n++) {
                                that.nextPingUrl = that.proxyList[n].trim();
                                that.currentUrl = that.proxyList[n].trim();
                            }
                            that.ping(that.currentUrl);
                        }
                    }else{
                        // 没有下一个，直接注册
                        that.pingNum = 0;
                        that.inRegister();
                    }
                }
            };
            that.objIMG.onerror = () => {
                console.log("ping "+this.currentUrl+"失败，未收到ping包");
                that.receNum++;
                this.pingicon = require('../../assets/image/signal0.png');
            }
        },
        // 循环ping值，显示在页面上
        pingFor: function () {

            // 保存上次数据
            if ( 0 < this.pingNum <= 4) {
                this.savePing();
            }

            this.pingDelays.splice(0, this.pingDelays.length);
            this.pingNum = 0;
            this.receNum = 0;
            this.ping(this.fastIp.ip);
        },
        // 保存ping值
        savePing: function () {
            let that = this;
            that.pingAvg = 0;
            for (let n = 1; n < that.pingDelays.length; n++) {
                that.pingAvg += that.pingDelays[n];
            }
            that.changePingIcon(Math.round(that.pingAvg / (this.pingDelays.length == 1 ? 1 : this.pingDelays.length - 1)),
                Math.round(that.receNum / (that.pingNum==0?1:that.pingNum)) * 100);
            let param = {
                pingIp: that.fastIp.ip,
                pingAvg: Math.round(that.pingAvg / (this.pingDelays.length == 1 ? 1 : this.pingDelays.length - 1)),
                pingRate: Math.round(that.receNum / (that.pingNum==0?1:that.pingNum)) * 100,
            };
            this.$http.post("pingRecord/doSave.json", param).then(function (res) {
                let result = res.data.flag;
                if (result != "666") {
                  if(res.data.msg){
                    console.error(res.data.msg);
                  }
                  return false;
                }
            });
        },
        // ping超时
        timeout: function () {
            this.receNum++;
        },
        changePingIcon: function (ping, rate) {
            this.sysping="ping:"+ping+"ms";
            if (ping>0 && ping<=30) {//信号好,图标绿
                this.pingicon = require('../../assets/image/signal5.png');
            } else if (ping > 30 && ping <= 50) {//信号中等,图标黄
                this.pingicon = require('../../assets/image/signal4.png');
            } else if (ping > 50 || rate < 100) {//信号差,图标红色
                this.pingicon = require('../../assets/image/signal2.png');
            } else {//无信号 灰色
                this.pingicon = require('../../assets/image/signal0.png');
            }
        },
        //保持当前登录
        checkIsAlive:function () {
            window.clearTimeout(this.keepAlive);
            this.keepAlive = "";
            let param={
              valueDate:this.valueDate,
            };
            let that = this;
            this.$http.post("login/keepLoginAlive.json",param).then(function (res) {
               let result = res.data.flag;
                if(result != "666"){
                  if (that.subscribeId) {
                    clearInterval(that.timeMount);
                  }
                  if(that.mqClient && that.mqClient.connected){
                    that.unRegested();
                    that.disconnect();
                  }
                  that.$alert(res.data.msg, '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                        that.outLogin("3");
                      }
                  });
                  return false;
                }
            });
            that.keepAlive = setTimeout(function () {
              that.checkIsAlive();
            },10000);
        },
        //
        shutDownAll:function () {
          window.clearTimeout(this.keepAlive);
          this.keepAlive = "";
          if (this.subscribeId) {
            clearInterval(this.timeMount);
          }
          if(this.mqClient && this.mqClient.connected){
            this.unRegested();
            this.disconnect();
          }
          let that = this;
          this.$alert("当前账号已在其他地方登录!", '提示', {
            confirmButtonText: '确定',
            callback: action => {
              that.outLogin("3");
            }
          });
        },
        // 清空消息
        clearMsg:function(){
            if(this.activeName == '1'){
                this.$Modal.confirm({
                    title: '清空确认',
                    content:'确定要清空消息列表吗？',
                    onOk:()=>{
                        let param = {
                            journalType:"清除通知",
                            menuId:"null",
                            employeeId: this.agentInfo.employeeId,
                        }
                        let that = this;
                        this.$http.post("orderNotice/doDelete.json",param).then(function (res) {  //工单未读消息查询
                            let result=res.data.flag;
                            if(result!="666"){
                                that.$Modal.info({
                                title:'提示',
                                content:res.data.msg
                                });
                                return false;
                            }
                        })

                        param={
                            empId:this.agentInfo.employeeId,
                            isRead:'1',
                        };
                        this.$http.post("notice/doEditEmp.json",param) .then(function (res) {
                          let result=res.data;
                          if(result.flag!="666"){
                            that.$Modal.info({
                              title:'提示',
                              content:res.data.msg
                            });
                            return false;
                          }
                          that.$store.commit('removeGlobalNoticeMsgList','clearAll');
                          that.$Message.success("清除成功");
                          that.noticeFlag = false;
                        })

                    },
                    onCancel:()=>{
                      return false;
                    }
                  })
            }else{
                this.$Modal.confirm({
                    title: '清空确认',
                    content:'确定要清空公告列表吗？',
                    onOk:()=>{
                        let that=this;
                        let param={
                            empId:this.agentInfo.employeeId,
                            isDelete:'1',
                        };
                        this.$http.post("notice/doEditEmp.json",param) .then(function (res) {
                          let result=res.data;
                          if(result.flag!="666"){
                            that.$Modal.info({
                              title:'提示',
                              content:res.data.msg
                            });
                            return false;
                          }
                          that.$Message.success("清除成功");
                          that.initNotice();
                        })

                    },
                    onCancel:()=>{
                      return false;
                    }
                  })
            }
            
        },
        // 通知点击
        clickNotice:function(msgFrom,uuid,topic,sessionChannel,item){

            if(sessionChannel == 'Notice'){
                let n=JSON.parse(item.noticeObj);
                n = this.noticeTable.find(item=> item.id==n.id);
                let that = this;
                let param={
                  noticeId:n.id,
                  empId:this.agentInfo.employeeId,
                  isRead:'1',
                };
              this.$http.post("notice/doEditEmp.json",param) .then(function (res) {
                let result=res.data;
                if(result.flag!="666"){
                  that.$Modal.info({
                    title:'提示',
                    content:res.data.msg
                  });
                  return false;
                }
                that.clicknoticeTable(n);
                that.$store.commit('removeNotice',uuid);
                return;
              })

            }
            if('chatOnLine' == msgFrom){
                this.getinto();
                this.$store.commit('removeGlobalNoticeMsgList',uuid);
                this.noticeFlag = false;
            }else if('workOrder' == msgFrom){
                this.$emit("openPeopleSet", "b_w_1-"+uuid+","+topic);
                let param = {
                    journalType:"点击通知",
                    menuId:"null",
                    orderId: uuid,
                    employeeId: this.agentInfo.employeeId,
                }
                let that = this;
                this.$http.post("orderNotice/doDelete.json",param).then(function (res) {  //工单未读消息查询
                    let result=res.data.flag;
                    if(result!="666"){
                        that.$Modal.info({
                        title:'提示',
                        content:res.data.msg
                        });
                        return false;
                    }
                    that.$store.commit('removeGlobalNoticeMsgList',uuid);
                    that.noticeFlag = false;
                })
            }

        },
        // 签入成功，获取在线客服消息
        getOnlineMsg:function(){
            let param = {
                journalType:"null",
                menuId:"null",
                type: '3',  //1待处理 2排队中,3全部
                pageNum: "0",
                pageSize: "0",
                }
                let that = this;
                this.$http.post("chatInterface/toWaitDeal.json",param).then(function (res) {  //待处理客户查询
                    let result=res.data.flag;
                    if(result!="666"){
                        that.$Modal.info({
                        title:'提示',
                        content:res.data.msg
                        });
                        return false;
                    }
                    let contentList = res.data.obj.list.content;
                    contentList.forEach(item => {
                        that.$store.commit('pushOnlineLeftInfo',item);
                        if(item.sessionType != 0 && Number(item.unreadCnt) > 0){
                            item['msgFrom'] = "chatOnLine";
                            item['content'] = item.lastMsg;
                            item['createTime'] = item.lastTime;
                            item['sessionChannel'] = item.channelType;
                            that.$store.commit('pushGlobalNoticeMsgList',item);
                        }
                    });
                })
        },
        // 签出成功，移除在线客服的消息提醒
        removeOnlineMsg:function(){
            let noticeInfos = this.$store.getters.getGlobalNoticeMsgList();
            if(noticeInfos){
                    noticeInfos.forEach(item => {
                        if(item.msgFrom == 'chatOnLine'){
                            this.$store.commit('removeGlobalNoticeMsgList',item.uuid);
                            this.$store.commit('delUnreadCnt',Number(item.unreadCnt));
                        }
                    });

            }
        },
        compare(attr){                  // 排序方法
            return function(a,b){
                let val1 = a[attr];
                let val2 = b[attr];
                return new Date(val2.replace(/-/,'/')) - new Date(val1.replace(/-/,'/'));
            }
        }
    },
    mounted() {
      window.addEventListener("beforeunload", e => {
        this.beforeunloadFn(e);
      });
    },
    created() {
        if('1' == this.agentInfo.employeeType){
          this.divWidth.width = "98%";
          this.divWidth.maxWidth = "98%";
        }
        this.valueDate = localStorage.getItem("valueTime"+this.agentInfo.companyCode+"_"+this.agentInfo.agentNumber);
        if(this.valueDate){
          let that = this;
          this.checkIsAlive();
          setTimeout(function () {
            that.connect();
          }, 2000);
        }
        this.initSearchTree("knowledgeTree");
        this.initSearch("1");
        this.haveAi=this.agentInfo.isAiAssistant;
        this.haveVideo=this.agentInfo.isSupportVideo;
        this.agentExten = this.agentInfo.agentExten;
        this.agentPassword = this.agentInfo.agentPassword;
        let agentNumber = this.agentInfo.agentNumber;
        if (!agentNumber || agentNumber == "undefined") {
            agentNumber = "暂无分机";
        };
        this.agentNumber = agentNumber;
        this.topic = "/queue/" + this.companyCode + "_" + agentNumber;
        if (this.agentInfo && this.agentInfo.employeeHead) {
            this.employeeHead = this.baseImgURL + this.agentInfo.employeeHead;
        };
        this.second = 0;
        this.hour = 0;
        this.minute = 0;
        this.getTime();
        this.screenHeight.height = this.mountHeight(50);
        this.tableHeight.height = this.mountHeight(105);
        let clientWidth = document.documentElement.clientWidth - 280;
        this.maskHeight.marginLeft = clientWidth + 'px';
        this.phoneType = localStorage.getItem("phoneType");
        // let autoSignIn = localStorage.getItem("autoSignIn");
        // if (autoSignIn == '1') {
        //     this.checkInOrOut();
        // }

        this.showChat = this.agentInfo.isSupportChat == '0' ? false : true;

        // this.unreadCnt = this.$store.getters.getUnreadMsgCnt();

// 快捷词登录后获取
        this.chatReplyWorkAndContent();
        // 登录后，将工单session设置为空
        localStorage.setItem("cacheOrderList", JSON.stringify({}));
    },
    destroyed() {
        clearInterval(this.intervalFlag);
      window.addEventListener("beforeunload", e => {
        this.beforeunloadFn(e);
      });
    },
    watch: {
        opacity1: function () {

        },
        unreadCnt: function(){
        },
        checkInOrOutText: function () {
            if (this.checkInOrOutText == '签出') {
                this.agentStatusList = [{
                    'id': '0',
                    'name': '空闲'
                }, {
                    'id': '6',
                    'name': '忙碌'
                }, {
                    'id': '8',
                    'name': '仅呼出'
                }];
            } else {
                this.agentStatusList = [{
                    'id': '-1',
                    'name': '离线'
                }, {
                    'id': '0',
                    'name': '空闲'
                }, {
                    'id': '1',
                    'name': '振铃'
                }, {
                    'id': '2',
                    'name': '通话'
                }, {
                    'id': '3',
                    'name': '保持'
                }, {
                    'id': '4',
                    'name': '后处理'
                }, {
                    'id': '5',
                    'name': '被占用'
                }, {
                    'id': '6',
                    'name': '忙碌'
                }, {
                    'id': '7',
                    'name': '离开'
                }, {
                    'id': '8',
                    'name': '仅呼出'
                }];
            }
        },
        noticeFlag: function(){
            if(this.noticeFlag){
                this.activeName='1';
                this.initNotice();
                this.noticeInfos = this.$store.getters.getGlobalNoticeMsgList();
                this.noticeInfos=this.noticeInfos.sort(this.compare('lastTime'));
            }
        }
    },

}
</script>

<style lang="less">
.remind .el-tabs__header{
    width: 80% !important;
}
.opacity {
    opacity: 1;
}
.skillselect .ivu-select-dropdown{
      overflow: auto;
}
.skillselect .ivu-select-item{
     overflow: hidden;
     text-overflow: ellipsis;
     white-space: nowrap;
}
.skillselect .ivu-select-selection{
    border:none;
}
.selectDiv .ivu-select-single .ivu-select-selection{
  height: 100%;
}
.selectDiv .ivu-select-selected-value{
  height: 100% !important;
  line-height: 1.5 !important;
}
// 提醒界面布局
.cuslist{
      overflow-y: auto;
      .listul{
        list-style: none;
        display: block;
        .listli{
          padding: 8px 0;
          border-bottom:1px solid #e4e7ed;
          padding-left:10px;
          padding-right:10px;
          .firstCE{
            display: flex;
            align-items: center;
            height: 30px;

            .channel{
              margin-right: 16px;
              margin-top: 10px;
              img{
                  max-width:27px;
                  max-height:27px;
                      width: 100%;
                      height: 100%;
              }
            }
            .cusdialog{
              width:85%;
              overflow: hidden;
                .cusname{
                  font-weight: bold;
                  color: #515a6e;
                  font-size: 15px;
                  line-height: 15px;
                  display:inline-block;
                }
                .tips{
                  border-radius: 50%;
                  margin-left:10px
                }
                .dialogrig{
                  float: right;
                  color:#515a6e;
                  font-size: 15px;
                  letter-spacing: 2px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  max-width: 150px;
                }
            }

          }
          .custext{
            color: rgba(0,0,0,.45);
            font-size: 14px;
            line-height: 30px;
            width:85%;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            margin-left: 45px;
            letter-spacing: 1px;
          }
          .lastfloor{
            display: flex;
            justify-content:space-between;
            width:85%;
            margin-left: 45px;
            .lasttime{
                color: rgba(0,0,0,.45);
                font-size: 14px;
                line-height: 14px;
            }
            .waittime{
              color:#e98a36;
              font-size: 14px;
                span{
                  margin-left:10px
                }
            }
          }
        }
      }
    }
.ivu-badge-count{
    height:18px !important;
    min-width:18px !important;
    padding:0 !important;
    line-height: 14px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/login/StandardSysHeadShow.vue